export default {
  currencyFormat: "#,###.##",
  thousandSeparator: ",",
  salesInvoiceEditor: {
    glAccountName: "اسم الحساب العام",
    glAccountNo: "رقم الحساب العام",
  },
  title: {
    store: "المتجر",
    budget: "الميزانية",
    receivable: "الذمم المدينة",
    client: "العميل",
    payable: "الذمم الدائنة",
    inventory: "المخزون",
    item: "الصنف",
    vendor: "المورد",
    masterData: "البيانات الرئيسية",
    closeIncomeStatement: "إغلاق بيان الدخل",
    storeRequisitionBatch: "دفعة طلب المتجر",
    generalPostingGroup: "مجموعة الترحيل العامة",
    generalProductPostingGroup: "مجموعة ترحيل المنتجات العامة",
    generalBusinessPostingGroup: "مجموعة ترحيل الأعمال العامة",
    clientPostingGroup: "مجموعة ترحيل العملاء",
    vendorPostingGroup: "مجموعة ترحيل الموردين",
    inventoryPostingGroup: "مجموعة ترحيل المخزون",
    bankAccountPostingGroup: "مجموعة ترحيل الحسابات البنكية",
    inventoryReconciliationSetup: "إعداد تسوية المخزون",
    expenseGeneralProductPostingGroup: "مجموعة ترحيل المصروفات العامة للمنتجات",
    expenseGeneralBusinessPostingGroup: "مجموعة ترحيل المصروفات العامة للأعمال",
    vatPostingGroup: "مجموعة ترحيل ضريبة القيمة المضافة",
    vatBusinessPostingGroup: "مجموعة ترحيل ضريبة القيمة المضافة للأعمال",
    vatProductPostingGroup: "مجموعة ترحيل ضريبة القيمة المضافة للمنتجات",
    vatPostingSetup: "إعداد ترحيل ضريبة القيمة المضافة",
    postingSetup: "إعداد الترحيل",
    generalPostingSetup: "إعداد الترحيل العام",
    inventoryPostingSetup: "إعداد ترحيل المخزون",
    userPostingSetup: "إعداد ترحيل المستخدم",
    signatureSetup: "إعداد التوقيع",
    generalLedger: "دفتر الأستاذ العام",
    chartOfAccount: "دليل الحسابات",
    chartOfAccountCategory: "فئة دليل الحسابات",
    chartOfAccountCategoryMenu: "فئة COA",
    generalLedgerBudget: {
      title: "استيراد من XLS",
      successImportData: "تم استيراد البيانات!",
    },
    balanceSheetConsolidation: {
      title: "تجميع الميزانية العمومية",
      titleReport: "تقرير تجميع الميزانية العمومية",
      excelFileID: "معرف ملف Excel لتجميع الميزانية العمومية",
      sheetFileID: "معرف Google Sheet لتجميع الميزانية العمومية",
    },
    generalJournal: "اليومية العامة",
    accountReconciliationJournal: "يومية تسوية الحسابات",
    newAccountReconciliationJournal: "يومية تسوية الحسابات الجديدة",
    generalConfiguration: "الإعدادات العامة",
    warehouseLocation: "موقع المستودع",
    accountingPeriod: "الفترة المحاسبية",
    inventoryPeriod: "فترة المخزون",
    bankAccount: "الحساب البنكي",
    paymentTerm: "شرط الدفع",
    generalJournalBatch: "دفعة اليومية العامة",
    numberSeries: "سلسلة الأرقام",
    purchaseRequisitionBatch: "دفعة طلب الشراء",
    unitOfMeasurement: "وحدة القياس",
    defaultUnitOfMeasurement: "وحدة الإدخال الافتراضية",
    baseUnitOfMeasurement: "وحدة القياس الأساسية",
    inputUnitOfMeasurement: "وحدة الإدخال",
    inputUnitOfMeasurementID: "معرف وحدة الإدخال",
    inputUnitOfMeasurementName: "اسم وحدة الإدخال",
    generalJournalTemplate: "قالب اليومية العامة",
    user: "المستخدم",
    purchaseRequest: "طلب شراء",
    purchaseOrder: "أمر شراء",
    purchasing: "المشتريات",
    purchaseReceiving: "استلام الشراء",
    purchaseReceiveCanceled: "استلام الشراء الملغى",
    outstandingPurchaseRequest: "طلبات الشراء المعلقة",
    vatBreakdown: "تفصيل ضريبة القيمة المضافة",
    purchaseRequestList: "قائمة طلبات الشراء",
    storeRequisitionList: "قائمة طلبات المتجر",
    storeRequisitionDetail: "تفاصيل طلب المتجر",
    postedStoreRequisitionList: "قائمة طلبات المتجر المرحلة",
    storeRequisition: "طلب المتجر",
    outstandingStoreRequisitionList: "قائمة طلبات المتجر المعلقة",
    outstandingPurchaseRequestList: "قائمة طلبات الشراء المعلقة",
    outstandingPurchaseRequestDetail: "تفاصيل طلب الشراء المعلق",
    purchasePayableSetup: "إعداد الذمم الدائنة للشراء",
    salesReceivableSetup: "إعداد الذمم المدينة للمبيعات",
    purchaseOrderDetail: "تفاصيل أمر الشراء",
    purchaseReceiptDetail: "تفاصيل إيصال الشراء",
    purchaseRequisitionTemplate: "قالب طلب الشراء",
    purchaseRequisition: "طلب شراء",
    purchaseRequestDetail: "تفاصيل طلب الشراء",
    purchaseInvoiceDetail: "تفاصيل فاتورة الشراء",
    currency: "العملة",
    generalLedgerSetup: "إعداد دفتر الأستاذ العام",
    inventorySetup: "إعداد المخزون",
    documentFlow: "تدفق المستندات",
    masterDocumentFlow: "تدفق المستندات الرئيسي",
    documentFlowSequenceType: "نوع تسلسل تدفق المستندات",
    purchaseInvoice: "فاتورة الشراء",
    purchaseCheck: "فحص بيانات الشراء",
    itemLedgerEntry: "قيد دفتر الأصناف",
    itemJournalBatch: "دفعة دفتر الأصناف",
    itemJournal: "دفتر الأصناف",
    physicalInventoryJournal: "دفتر الجرد الفعلي",
    vendorLedgerEntry: "قيد دفتر المورد",
    vendorLedgerEntryDetail: "تفاصيل قيد دفتر المورد",
    clientLedgerEntry: "قيد دفتر العميل",
    clientLedgerEntryDetail: "تفاصيل قيد دفتر العميل",
    bankAccountLedgerEntry: "قيد دفتر الحساب البنكي",
    bankAccountLedgerEntryDetail: "تفاصيل قيد دفتر الحساب البنكي",
    physicalInventoryLedgerEntry: "قيد الجرد الفعلي",
    vatEntry: "قيد ضريبة القيمة المضافة",
    valueEntry: "قيد القيمة",
    itemApplicationEntry: "قيد تطبيق الصنف",
    averageCostCalculationEntry: "قيد حساب التكلفة المتوسطة",
    generalJournalEntry: "قيد اليومية العامة",
    postedDocuments: "المستندات المرحلة",
    postedPurchaseRequest: "طلب الشراء المرحل",
    postedPurchaseOrder: "أمر الشراء المرحل",
    postedPurchaseReceipt: "إيصال الشراء المرحل",
    postedPurchaseInvoice: "فاتورة الشراء المرحلة",
    postedPurchaseCreditMemo: "إشعار دائن للشراء مرحل",
    postedSalesInvoice: "فاتورة المبيعات المرحلة",
    postedSalesCreditMemo: "إشعار دائن للمبيعات مرحل",
    purchaseCreditMemo: "إشعار دائن للشراء",
    postedStoreRequisition: "طلب المتجر المرحل",
    postedReceivableInvoice: "فاتورة الذمم المدينة المرحلة",
    entries: "القيود",
    outstandingStoreRequisition: "طلب المتجر المعلق",
    adjustmentEntry: "قيد التعديل",
    generalLedgerEntry: "قيد دفتر الأستاذ العام",
    paymentJournal: "دفتر المدفوعات",
    cashReceiptJournal: "دفتر إيصالات النقد",
    salesInvoice: "فاتورة المبيعات",
    salesInvoiceLine: "سطر فاتورة المبيعات",
    salesCreditMemo: "إشعار دائن للمبيعات",
    appliedEntries: "القيود المطبقة",
    reports: "التقارير",
    unapplyClientEntries: "إلغاء تطبيق قيود العميل",
    applyClientEntries: "تطبيق قيود العميل",
    unapplyVendorEntries: "إلغاء تطبيق قيود المورد",
    applyVendorEntries: "تطبيق قيود المورد",
    reverseTransaction: "عكس المعاملة",
    vendorBankAccount: "الحساب البنكي للمورد",
    reportSetting: "إعداد التقرير",
    itemJournalMasterTemplate: "قالب دفتر الأصناف الرئيسي",
    generalJournalMasterTemplate: "قالب اليومية العامة الرئيسي",
    journalVoucher: "قسيمة اليومية",
    paymentVoucher: "قسيمة الدفع",
    receivableInvoice: "فاتورة الذمم المدينة",
    accountReceivableAgingCreditCard: "تقادم الذمم المدينة لبطاقات الائتمان",
    agingCreditCardReport: "تقرير تقادم بطاقات الائتمان",
    accountReceivablePaymentList: "قائمة مدفوعات الذمم المدينة",
    accountReceivablePaymentListCard: "قائمة مدفوعات الذمم المدينة للبطاقات",
    accountReceivablePaymentListLedger: "قائمة مدفوعات الذمم المدينة (دفتر)",
    purchaseRequestApproval: "موافقة طلب الشراء",
    approval: "موافقة",
    printOption: "خيار الطباعة",
    purchaseBookOption: "خيار دفتر الشراء",
    inventoryReconciliation: "تسوية المخزون",
    entryEditorChangeAccountNumber: "تغيير رقم الحساب",
    entryEditorChangeDescription: "تغيير الوصف",
    entryEditorChangeBankAccount: "Change Bank Account",
    entryEditorChangesLog: "سجل التغييرات",
    accountPayablePaymentList: "قائمة مدفوعات الذمم الدائنة",
    deleteBankAccountLedgerEntry: "حذف قيد دفتر الحساب البنكي",
    deleteBankAccountLedgerEntryDialog: "مربع حوار حذف قيد دفتر الحساب البنكي",
    choose: "اختر",
    reopen: "إعادة فتح",
    gle: "دفتر الأستاذ العام للمؤسسة",
    baleDetail: "تفاصيل BALE",
    bale: "BALE",
    chooseBaleEntry: "اختر قيد BALE",
    confirmReopenClosedEntry: "تأكيد إعادة فتح القيد المغلق",
    confirmDeleteGLE: "تأكيد حذف GLE",
    confirmDeleteBaleDetail: "تأكيد حذف تفاصيل BALE",
    confirmDeleteBale: "تأكيد حذف BALE",
    documentApproval: "موافقة المستند",
    deletePostedInvoice: "حذف الفاتورة المرحلة",
    movePurchaseInvoiceLines: "نقل بنود فاتورة الشراء",
    purchaseRequestApprovalDetail: "تفاصيل موافقة طلب الشراء",
    purchaseOrderApprovalDetail: "تفاصيل موافقة أمر الشراء",
    storeRequestApprovalDetail: "تفاصيل موافقة طلب المتجر",
    withdrawDocumentApproval: "سحب موافقة المستند",
    changeStatus: "تغيير الحالة",
    changeStatusPurchaseRequisition: "تغيير حالة طلب الشراء",
    cle: "CLE",
    vle: "VLE",
    cleDetail: "تفاصيل CLE",
    vleDetail: "تفاصيل VLE",
    chooseCleEntry: "اختر قيد CLE",
    chooseVleEntry: "اختر قيد VLE",
    confirmDeleteCleDetail: "تأكيد حذف تفاصيل CLE",
    confirmDeleteCle: "تأكيد حذف CLE",
    confirmDeleteVleDetail: "تأكيد حذف تفاصيل VLE",
    confirmDeleteVle: "تأكيد حذف VLE",
    deleteClientLedgerEntry: "حذف CLE",
    deleteClientLedgerEntryDialog: "مربع حوار حذف CLE",
    deleteVendorLedgerEntry: "حذف VLE",
    deleteVendorLedgerEntryDialog: "مربع حوار حذف VLE",
    updateWitholdingTax: "تحديث ضريبة الاستقطاع",
    adjustmentTools: "أدوات التعديل",
    directExpenseGenBusPostGroup: "مجموعة ترحيل المصروفات المباشرة (الأعمال)",
    directExpenseGenProdPostGroup: "مجموعة ترحيل المصروفات المباشرة (المنتج)",
    directExpenseAdjustmentAccount: "حساب تسوية المصروفات المباشرة",
    defaultDirectExpenseGenBusPostGroup: "مجموعة المصروفات المباشرة الافتراضية (الأعمال)",
    custPostGroup: "مجموعة ترحيل العملاء",
    vendorPostGroup: "مجموعة ترحيل الموردين",
    journalTemplate: "قالب دفتر اليومية",
    noSeries: "سلسلة الأرقام",
    defaultLocation: "الموقع الافتراضي",
    prefix: "بادئة",
    startingNumber: "الرقم الابتدائي",
    endingNumber: "الرقم النهائي",
    lastNumberUsed: "آخر رقم مستخدم",
    lengthOfNumber: "طول الرقم",
    includeYear: "تضمين السنة",
    includeMonth: "تضمين الشهر",
    includeDate: "تضمين التاريخ",
    isEditable: "قابل للتعديل",
    branch: "فرع",
    bankAccountNo: "رقم الحساب البنكي",
    virtualAccountNo: "رقم الحساب الافتراضي",
    allowPostingFrom: "السماح بالترحيل من",
    allowPostingTo: "السماح بالترحيل إلى",
    receivableAccount: "حساب الذمم المدينة",
    receivableAccountNo: "رقم حساب الذمم المدينة",
    payableAccount: "حساب الذمم الدائنة",
    balanceAccount: "حساب الرصيد",
    accountCategory: "فئة الحساب",
    accountType: "نوع الحساب",
    directPost: "ترحيل مباشر",
    blocked: "محظور",
    vatPercentage: "نسبة ضريبة القيمة المضافة",
    startingDate: "تاريخ البدء",
    closed: "مغلق",
    endingDate: "تاريخ الانتهاء",
    dueDateCalc: "حساب تاريخ الاستحقاق",
    debitAmount: "مبلغ مدين",
    creditAmount: "مبلغ دائن",
    amount: "المبلغ",
    isApplied: "تم التطبيق",
    appliedSalesInvoiceId: "معرف فاتورة المبيعات المطبقة",
    appliedSalesCreditMemoId: "معرف إشعار الدائن للمبيعات المطبق",
    cashDeskMovementId: "معرف حركة الصندوق",
    purchaseInvoiceApprovalDetail: "تفاصيل موافقة فاتورة الشراء",
    adjustSingleEntry: "تعديل إدخال فردي",
    adjustSOH: "ضبط SOH",
    adjustCostItemEntries: "تعديل إدخالات عناصر التكلفة",
    documentAttachment: "إرفاق مستند",
    recallJournal: "سجل الاسترجاع",
    reverseJournal: "دفتر عكسي",
    inventoryAccountBalanceDetail: "تفاصيل رصيد حساب المخزون",
    recalled: "تم سحبه",
    changeClient: "تغيير العميل",
    itemCostPerLocation: "تكلفة العنصر لكل موقع",
    integration: "تكامل",
    revaluationJournalAllItems: "دفتر يومية إعادة التقييم جميع العناصر",
    interDepartmentTransferDetail: "تفاصيل النقل بين الأقسام",
    revertPostedSalesInvoice: "إلغاء فاتورة المبيعات المنشورة",
    generalLedgerEntryChangesLogs: "سجلات تغييرات قيود دفتر الأستاذ العام",
    changeItem: "غيّر {item}",
    itemJournalLog: "سجل العناصر",
    changesLogs: "سجل التغييرات",
    cancelledPurchaseReceipts: "إيصالات شراء ملغاة",
    newPaymentJournal: "دفتر دفع جديد",
    newCashReceiptJournal: "دفتر إيصالات النقد الجديدة",
    itemsWithIncorrectCosts: "عناصر بتكاليف غير صحيحة",
    ve: "VE",
    chooseVeEntry: "اختر إدخال VE",
    confirmDeleteVe: "تأكيد حذف VE",
    deleteValueEntry: "حذف VE",
    deleteValueEntryDialog: "حذف قيمة الإدخال",
    deleteGeneralJournalEntryDialog: "حذف سجل اليومية العامة",
    selfBilledInvoice: "فاتورة ذاتية الفوترة",
    taxIntegrationLog: "سجل تكامل الضريبة",
    updateStoreRequisition: "تحديث حالة طلب المتجر",
    printoutLayout: "تخطيط الطباعة",
    adjustPostingDate: "تعديل تاريخ النشر",
    invoiceEmailLog: "سجل بريد الفاتورة",
    inventoryPostingGroups: "مجموعات نشر المخزون",
    entryEditorChangeAccountNumberAndDescription: "تغيير رقم الحساب والوصف",
    revertPostedPurchaseInvoice: "إلغاء فاتورة الشراء المنشورة",
    changeLineStatus: "تغيير حالة الخط",
    dimension: "الأبعاد",
    dimensionValueType: "نوع قيمة البعد",
    dimensionValue: "قيمة الأبعاد",
    dimensionOption: "خيار الأبعاد",
    coaDimension: "أبعاد COA",
    coaDimensionOptions: "خيارات أبعاد COA",
    coaDimensionMatrix: "مصفوفة أبعاد COA",
    updateCoaDimensionMapping: "تحديث خريطة أبعاد COA",
    defaultDimension: "الأبعاد الافتراضية",
    dimensionRule: "قاعدة الأبعاد",
    dimensionRules: "قواعد الأبعاد",
    allowedDimensionValues: "قيم الأبعاد المسموح بها",
    documentDimension: "أبعاد الوثيقة",
    approvalDocumentWithdrawal: "سحب مستند الموافقة",
    deleteEntries: "حذف الإدخالات",
    confirmDeletePurchaseInvoice: "تأكيد حذف فاتورة الشراء",
    storeRequisitionTemplate: "نموذج طلب المتجر",
    deletePostedMemo: "حذف المذكرة المنشورة",
    entryEditorChangeDimensionSet: "تغيير مجموعة الأبعاد",
    revertPostedPurchaseCreditMemo: "إرجاع مذكرة ائتمان الشراء المنشورة",
    ytdAddAdditionalYear: "إضافة سنة إضافية (مقارنة تقرير YTD)",
    depositAccountPostingGroup: "مجموعة تسجيل حساب الإيداع",
    depositAccount: "حساب الإيداع",
    depositAccountLedgerEntry: "إدخال دفتر حساب الإيداع",
    depositAccountLedgerEntryDetail: "تفاصيل قيد دفتر حساب الإيداع",
    deleteDepositAccountLedgerEntry: "حذف DALE",
    deleteDepositAccountLedgerEntryDialog: "حذف سجل حساب الإيداع",
    daleDetail: "تفاصيل دالي",
    dale: "دايل",
    chooseDaleEntry: "اختر إدخال البيانات",
    confirmDeleteDaleDetail: "تأكيد حذف تفاصيل DALE",
    confirmDeleteDale: "تأكيد حذف DALE",
    interDepartmentTransferApprovalDetail: "تفاصيل موافقة النقل بين الأقسام",
    dimensionLevel: "مستوى الأبعاد",
    generalBudgetEntry: "إدخال الميزانية العامة",
    generalBudgetJournal: "دفتر الميزانية العامة",
    reportByDimension: "تقرير حسب البعد",
    profitAndLossBudgetSource: "مصدر ميزانية الأرباح والخسائر",
    deleteSelectedInvoices: "حذف الفواتير المحددة",
    confirmDimensionSet: "تأكيد مجموعة الأبعاد",
    cashFlowBudget: "ميزانية التدفق النقدي",
    interDepartmentTransfer: "نقل بين الأقسام",
    interDepartmentTransferBatch: "دفعة نقل بين الأقسام",
  },
  word: {
    entryNo: "رقم القيد",
    chooseThePrintingPageSize: "اختر حجم صفحة الطباعة",
    changedTo: "إلى",
    chooseThePurchaseBookOption: "اختر خيار دفتر المشتريات",
    importRejected: "تم رفض الاستيراد. قم بإصلاح هذه الصفوف ثم استورد مرة أخرى.",
    importWithReservationSuccess: "تم استيراد {invoices} فاتورة و{reservations} حجز.",
  },
  main: {
    search: "بحث",
    account: "الحساب",
    interimAccount: "حساب مؤقت",
  },
  form: {
    purchaseOrders: "أوامر الشراء",
    purchaseRequest: "طلب شراء",
    outstandingPurchaseRequest: "طلب شراء معلق",
    receiving: "استلام",
    info: "معلومات",
    vendors: "الموردون",
    items: "الأصناف",
    breakdowns: "تفاصيل",
  },
  button: {
    directExpense: "تعيين كمصروف مباشر",
    correction: "تصحيح تطبيق ثابت",
    setVendor: "تعيين المورد",
    getLastDirectCost: "الحصول على آخر تكلفة مباشرة",
    preview: "معاينة",
    resetEntry: "إعادة تعيين جميع القيود",
    manageBankAccount: "إدارة الحساب البنكي",
    viewDetail: "عرض التفاصيل",
    viewAppliedEntries: "القيود المطبقة",
    viewEntries: "عرض القيود",
    previewUndoReceipt: "معاينة إلغاء الاستلام",
    cancelReceipt: "إلغاء الاستلام",
    previewCancelReceipt: "معاينة إلغاء الاستلام",
    delete: "حذف",
    createCreditMemo: "إنشاء إشعار دائن تصحيحي",
    calculateInventory: "حساب المخزون",
    refreshUnitCost: "تحديث تكلفة الوحدة",
    upload: "رفع",
    download: "تنزيل",
    downloadTemplate: "تنزيل النموذج",
    previewData: "معاينة البيانات",
    import: "استيراد",
    view: "عرض",
    new: "جديد",
    edit: "تعديل",
    ok: "موافق",
    cancel: "إلغاء",
    save: "حفظ",
    recalculateAverageCost: "إعادة حساب متوسط التكلفة",
    add: "إضافة",
    choose: "اختيار",
    print: "طباعة",
    post: "ترحيل",
    unpost: "إلغاء الترحيل",
    previewPost: "معاينة الترحيل",
    printSupplierComparison: "طباعة مقارنة الموردين",
    insertFromTemplate: "إدراج من قالب",
    applyEntries: "تطبيق القيود",
    unapplyEntries: "إلغاء تطبيق القيود",
    process: "معالجة",
    processToPo: "معالجة إلى أمر شراء",
    reject: "رفض",
    decline: "إلغاء",
    approve: "موافقة",
    submitApproval: "إرسال للموافقة",
    reopen: "إعادة فتح",
    release: "إصدار",
    select: "اختيار",
    close: "إغلاق",
    move: "نقل",
    clear: "مسح",
    saveChange: "حفظ التغييرات",
    saveAsTemplate: "حفظ كقالب",
    addNewTemplate: "إضافة قالب جديد",
    AddFromReceipt: "إضافة من الاستلام",
    reset: "إعادة تعيين",
    apply: "تطبيق",
    addFilter: "إضافة فلتر",
    navigate: "تنقل",
    reverse: "عكس",
    forceClose: "إغلاق إجباري",
    receiveAll: "تعيين استلام الكل",
    ClearReceive: "مسح الاستلام",
    closePeriod: "إغلاق الفترة",
    reopenPeriod: "إعادة فتح الفترة",
    reopenPeriodForce: "إعادة فتح الفترة (إجباري)",
    closeMonthPeriod: "إغلاق الشهر",
    reopenMonthPeriod: "إعادة فتح الشهر",
    reopenMonthPeriodForce: "إعادة فتح الشهر (إجباري)",
    closeYearPeriod: "إغلاق السنة",
    reopenYearPeriod: "إعادة فتح السنة",
    viewPrice: "عرض السعر",
    newItem: "عنصر جديد",
    splitItem: "تقسيم العنصر",
    postAndPrint: "ترحيل وطباعة",
    vendorEntries: "قيود المورد",
    postBatch: "ترحيل دفعة",
    getPostedSalesInvoice: "الحصول على فاتورة مبيعات مرحلة",
    setQtyToZero: "تعيين الكمية إلى صفر",
    showOpenOnly: "عرض المفتوح فقط",
    history: "السجل",
    released: "تم الإصدار",
    deleted: "تم الحذف",
    showData: "عرض البيانات",
    newItemFromPR: "عنصر جديد من طلب شراء",
    setReconciled: "تعيين كمطابق",
    unsetReconciled: "إلغاء المطابقة",
    downloadToGSheet: "إلى GSheet",
    downloadToExcel: "إلى Excel",
    downloadToPDF: "إلى PDF",
    goToSetup: "الذهاب إلى الإعدادات",
    goToInvReconSetup: "الذهاب إلى إعدادات تسوية المخزون",
    goToInventorySetup: "الذهاب إلى إعدادات المخزون",
    applyEntriesFromInvoice: "تطبيق القيود من الفاتورة",
    applyEntriesFromCreditMemo: "تطبيق القيود من إشعار دائن",
    submit: "إرسال",
    submitForApproval: "إرسال للموافقة",
    deleteAll: "حذف الكل",
    approvalDetail: "تفاصيل الموافقة",
    delegate: "تفويض",
    withdraw: "سحب",
    previewAdjustCostEntries: "معاينة قيود تعديل التكلفة",
    adjustCostEntries: "تعديل قيود التكلفة",
    splitInvoice: "تقسيم الفاتورة",
    selectAll: "اختيار الكل",
    unselectAll: "إلغاء اختيار الكل",
    back: "رجوع",
    next: "التالي",
    confirm: "تأكيد",
    recall: "استرجاع",
    refresh: "تحديث",
    viewAccount: "عرض الحساب",
    viewDimension: "عرض البُعد",
    undoForceClose: "إلغاء الإغلاق الإجباري",
    adjustValueEntryAmount: "تعديل مبلغ قيد القيمة",
    updateLowestUnitCostVendorComparison: "تحديث تكلفة الوحدة بأقل سعر مورد",
    importHOAInvoice: "استيراد فاتورة HOA",
    deleteBy: "احذف بواسطة {f}",
    deleteByIleId: "حذف بواسطة معرف ILE",
    deleteByDocumentNo: "حذف برقم الوثيقة",
    newSet: "مجموعة جديدة",
    invoicedOnly: "فواتير فقط",
    updateStatus: "تحديث الحالة",
    undo: "تراجع",
    clearAll: "مسح الكل",
    recalculateInventory: "إعادة حساب المخزون",
    revert: "استرجاع",
    lineStatusFilter: "فلتر حالة الخط",
    create: "إنشاء",
    selectDimensionValues: "اختر قيم الأبعاد",
    includeClosedInvoice: "تضمين الفاتورة المغلقة",
    includeClosedEntry: "تضمين الإدخال المغلق",
    addDimension: "إضافة بُعد",
    approvalNotes: "ملاحظات الموافقة",
    importInvoiceWithReservation: "استيراد الفاتورة مع الحجز",
    readSheet: "اقرأ الورقة",
    newLine: "خط جديد",
  },
  excel: {
    excel: "Excel",
    upload: "تحميل",
    uploadInsert: "تحميل (إدراج)",
    uploadUpdate: "تحميل (تحديث)",
    download: "تنزيل",
    downloadTemplate: "تنزيل النموذج",
    preview: "معاينة البيانات",
    import: "استيراد",
    cancel: "إلغاء",
    importSuccess: "تم الاستيراد بنجاح",
    importFailed: "فشل الاستيراد",
    downloadFailed: "فشل تنزيل البيانات",
    parseFailed: "فشل تحليل ملف Excel",
    noValidRows: "لا توجد صفوف صالحة للاستيراد",
    noDataRows: "الملف لا يحتوي على صفوف بيانات",
    invalidFileType: "يتم دعم ملفات .xlsx فقط",
    fileTooLarge: "يجب أن يكون حجم الملف أقل من {size}MB",
    showingTruncated: "يتم عرض {limit} من {total} صف — سيتم استيراد جميع الصفوف الـ {total}.",
    missingColumns: "تم حظر الاستيراد — أعمدة متوقعة مفقودة: {columns}. يرجى إعادة تنزيل القالب.",
  },
  select: {
    base: "اختر {f}",
  },
  reports: {
    allVendor: "جميع الموردين",
    noVendor: "لا يوجد مورد",
    vendorList: "قائمة الموردين",
    earliestPostingDate: "أبكر تاريخ ترحيل",
    latestPostingDate: "أحدث تاريخ ترحيل",
    selectVendor: "اختر المورد",
    detailLocationSummary: "ملخص الموقع التفصيلي",
    pnlFileID: "معرف ملف الأرباح والخسائر {f}",
    exportPnl: "الأرباح والخسائر {f}",
    pnlID: "معرف الأرباح والخسائر {f}",
    downloadToExcel: "تنزيل إلى Excel",
    profitAndLossCurrentMonthConsolidationExcelFileID: "معرف ملف Excel لتجميع الأرباح والخسائر للشهر الحالي",
    profitAndLossYTDConsolidationExcelFileID: "معرف ملف Excel لتجميع الأرباح والخسائر منذ بداية السنة",
    profitAndLossYTDSummaryExcelFileID: "معرف ملف Excel لملخص الأرباح والخسائر منذ بداية السنة",
    balanceSheetExcelFileID: "معرف ملف Excel للميزانية العمومية",
    dailyFlashCostExcelFileID: "معرف ملف Excel لتكلفة الفلاش اليومية",
    DRRExcelFileID: "معرف ملف Excel لـ DRR",
    FBMealCoverExcelFileID: "معرف ملف Excel لـ FB Meal Cover",
    profitAndLossCurrentMonthConsolidationGoogleSheetFileID: "معرف Google Sheet لتجميع الأرباح والخسائر للشهر الحالي",
    profitAndLossYTDConsolidationGoogleSheetFileID: "معرف Google Sheet لتجميع الأرباح والخسائر منذ بداية السنة",
    profitAndLossYTDSummaryGoogleSheetFileID: "معرف Google Sheet لملخص الأرباح والخسائر منذ بداية السنة",
    balanceSheetGoogleSheetFileID: "معرف Google Sheet للميزانية العمومية",
    dailyFlashCostGoogleSheetFileID: "معرف Google Sheet لتكلفة الفلاش اليومية",
    DRRGoogleSheetFileID: "معرف Google Sheet لـ DRR",
    FBMealCoverGoogleSheetFileID: "معرف Google Sheet لـ FB Meal Cover",
    startInventoryAccountNumber: "رقم حساب بداية المخزون",
    endInventoryAccountNumber: "رقم حساب نهاية المخزون",
    accountPayableInterim: "حسابات دائنة مؤقتة",
    inventoryDiscrepancyReport: "تقرير اختلافات المخزون",
    inventoryFoodDiscrepancy: "اختلافات مخزون الطعام",
    inventoryBeverageDiscrepancy: "اختلافات مخزون المشروبات",
    invAccBalanceSOHDiscrepancy: "اختلاف رصيد حساب المخزون وكمية المخزون الفعلية",
    financialReport: "تقرير مالي",
    accountPayableReport: "تقرير الحسابات الدائنة",
    accountReceivableReport: "تقرير الحسابات المدينة",
    inventoryReport: "تقرير المخزون",
    frontOfficeReport: "تقرير الاستقبال",
    balanceSheet: "الميزانية العمومية",
    trialBalance: "ميزان المراجعة",
    profitAndLoss: "الأرباح والخسائر",
    profitAndLossYTDSummary: "ملخص الأرباح والخسائر منذ بداية السنة",
    profitAndLossCurrentMonthConsolidation: "تجميع الأرباح والخسائر للشهر الحالي",
    profitAndLossYTDConsolidation: "تجميع الأرباح والخسائر منذ بداية السنة",
    accountPayableAging: "تقادم الحسابات الدائنة",
    accountPayableInterimAging: "تقادم الحسابات الدائنة المؤقتة",
    accountPayablePaymentList: "قائمة مدفوعات الحسابات الدائنة",
    accountReceivableAging: "تقادم الحسابات المدينة",
    accountReceivableAgingCard: "تقادم الحسابات المدينة (بطاقات)",
    accountReceivablePaymentList: "قائمة مدفوعات الحسابات المدينة",
    accountReceivablePaymentListCard: "قائمة مدفوعات الحسابات المدينة (بطاقات)",
    accountReceivablePaymentListLedger: "قائمة مدفوعات الحسابات المدينة (دفتر)",
    inventoryAccountBalanceDetail: "تفاصيل رصيد حساب المخزون",
    stockOnHand: "المخزون المتوفر",
    topPurchaseItem: "أكثر الأصناف شراءً",
    topPurchaseByVendor: "أكثر المشتريات حسب المورد",
    topPurchaseByVendorReport: "تقرير أكثر المشتريات حسب المورد",
    vendorReport: "تقرير المورد",
    dailyFlashCost: "تكلفة الفلاش اليومية",
    slowMovingInventory: "مخزون بطيء الحركة",
    itemExpense: "مصاريف الأصناف",
    receivingReport: "تقرير الاستلام",
    inventoryReconciliation: "تسوية المخزون",
    itemReorder: "إعادة ترتيب الأصناف",
    outstandingPurchaseOrder: "أمر شراء معلق",
    forceClosedPurchaseOrder: "أمر شراء مغلق قسراً",
    purchasingReport: "تقرير المشتريات",
    inventoryMovementReport: "تقرير حركة المخزون",
    guestAccountBalance: "رصيد حساب الضيف",
    FOClosingCashier: "إغلاق كاشير الاستقبال",
    POSClosingCashier: "إغلاق كاشير نقاط البيع",
    dailyRevenueReport: "تقرير الإيرادات اليومية",
    FBMealCover: "FB Meal Cover",
    incomeAudit: "تدقيق الإيرادات",
    budgetRevenue: "إيرادات الميزانية",
    budgetStatistic: "إحصائيات الميزانية",
    showGuestAccountName: "عرض اسم الضيف/الحساب",
    showSalesPersonName: "عرض اسم مندوب المبيعات",
    showContactName: "عرض اسم جهة اتصال العميل",
    agingDate: "تاريخ التقادم",
    discrepancyReport: "تقرير الفروقات",
    discrepancy: "فرق",
    agingBy: "حسب التقادم",
    arAgingReport: "تقرير تقادم الحسابات المدينة",
    cardAgingReport: "تقرير تقادم البطاقات",
    arAgingAccountSetup: "إعداد حساب تقادم الحسابات المدينة",
    arAgingAccountSetupNotes: "يستخدم في تقرير تقادم الحسابات المدينة",
    apAgingAccountSetup: "إعداد حساب تقادم الحسابات الدائنة",
    apAgingAccountSetupNotes: "يستخدم في تقرير تقادم الحسابات الدائنة",
    arAgingDiscrepancyReport: "تقرير فروقات تقادم الحسابات المدينة",
    arAgingDiscrepancy: "فرق تقادم الحسابات المدينة",
    apAgingDiscrepancyReport: "تقرير فروقات تقادم الحسابات الدائنة",
    apAgingDiscrepancy: "فرق تقادم الحسابات الدائنة",
    bankAccountAgingDiscrepancyReport: "تقرير فروقات تقادم الحسابات البنكية",
    bankAccountAgingDiscrepancy: "فرق تقادم الحسابات البنكية",
    arAgingCardAndLedger: "تقادم الحسابات المدينة (بطاقات ودفتر)",
    arAgingCardAndLedgerReport: "تقرير تقادم الحسابات المدينة (بطاقات ودفتر)",
    TBSummaryGoogleSheetFileID: "ملف معرف جدول ميزان المراجعة في جوجل شيت",
    TBSummaryExcelFileID: "ملف Excel لملخص ميزان المراجعة",
    gsheetTemplateIsNotConfiguredYet: "لم يتم تكوين نموذج Ghseet بعد",
    excelTemplateIsNotConfiguredYet: "قالب Excel غير مُعد بعد",
    downloadAsMacro: "تحميل كملف ماكرو",
    balanceSheetYTDSummary: "ملخص الميزانية العمومية حتى تاريخه",
    accountScheduleConsolidation: "توحيد جدول الحسابات",
    accountScheduleConsolidationReport: "تقرير دمج جدول الحسابات",
    accountScheduleConsolidationExcelFileID: "معرّف ملف إكسل لتوحيد جدول الحسابات",
    accountScheduleConsolidationGoogleSheetFileID: "معرّف ملف جدول تجميع حسابات جوجل شيت",
    notAvailableForPreview: "{item} غير متاح للمعاينة. يرجى تحميل التقرير لعرض هذه البيانات.",
    trialBalanceYTD: "ميزان المراجعة حتى الآن",
    itemConsumptionReport: "تقرير استهلاك العناصر",
    interfaceJournal: "مجلة الواجهة",
    includeDimension: "تضمين أعمدة الأبعاد",
    useReceivableDateAging: "استخدم تاريخ استحقاق العمر / تاريخ النشر",
    accountPayableInterimIsNotConfiguredYet: "حساب الدفعات المؤقت غير مُعد بعد. يرجى إعداده في إعداد التقرير.",
    accountPayableInterimAccountNotFound: "لم يتم العثور على حساب المدفوعات المؤقتة المكونة في دليل الحسابات.",
    cashFlowExcelFileID: "معرّف ملف تدفق النقدية Excel",
    cashFlowYTDSummaryExcelFileID: "ملف إكسل ملخص التدفق النقدي حتى الآن",
    excelTemplateNotUploaded: "لم يتم رفع نموذج إكسل بعد. قم برفعه في البيانات الرئيسية > الإعدادات العامة > إعداد التقرير.",
    cashFlow: "تدفق نقدي",
    cashFlowYTDSummary: "ملخص التدفق النقدي حتى الآن",
    cashFlowNotConfigured: "لا يوجد بُعد تدفق نقدي مُهيأ. أضف واحدًا تحت إعدادات دفتر الأستاذ العام → التقرير حسب البُعد → التدفق النقدي.",
    actualCurrentMonth: "الشهر الحالي",
    budgetCurrentMonth: "ميزانية الشهر الحالي",
    actualLastMonth: "آخر شهر فعلي",
    actualLastYear: "السنة الماضية الفعلية",
    actualYTDCurrentMonth: "السنة الحالية حتى الآن الشهر الحالي",
    budgetYTDCurrentMonth: "الميزانية حتى الآن - الشهر الحالي",
    actualYTDLastYear: "الفعلي حتى تاريخه العام الماضي",
    cashFlowByDepartmentExcelFileID: "معرّف ملف إكسل تدفق النقد حسب القسم",
    cashFlowByDepartment: "تدفق النقد حسب القسم",
    cashFlowByDepartmentNotConfigured: "قم بتكوين بعدين تحت إعداد دفتر الأستاذ العام → التقرير حسب البعد → التدفق النقدي حسب القسم: الأول هو محور الصف، والثاني هو محور العمود.",
    cashFlowMonthToDate: "الشهر حتى الآن",
    cashFlowYearToDate: "السنة حتى الآن",
    cashFlowUnassigned: "غير مخصص",
    cashFlowTotal: "الإجمالي",
  },
  status: {
    pleaseWait: "يرجى الانتظار...",
    loadingpleaseWait: "جارٍ التحميل... يرجى الانتظار",
    trialBalanceDetail: {
      generatingData: "جاري إنشاء تفاصيل ميزان المراجعة. يرجى الانتظار؛ قد يستغرق ذلك بعض الوقت. يمكنك إغلاق النافذة أو الانتقال لصفحة أخرى؛ ستستمر العملية.",
      readyForDownload: "جميع ملفات Excel للفترة جاهزة للتنزيل",
      sendEmail: "وإرسال إلى البريد الإلكتروني:",
      exclusiveDownload: "نتائج ميزان المراجعة التفصيلية غير متاحة للعرض على الويب ويمكن الوصول إليها فقط من خلال تنزيل الملف. <br> للمجموعات التي تحتوي على أكثر من 5,000 صف، يرجى استخدام خيار تنزيل Excel.",
      gsheeRowLimitExceeded: "تم تجاوز حد الصفوف في Google Sheets. يرجى تنزيل الملف كوثيقة Excel.",
      downloadPartialMessage: "سيتم تقسيم ملف تنزيل ميزان المراجعة حسب الشهر. يرجى عدم إغلاق المتصفح أثناء هذه العملية.",
      periodStarted: "تم بدء إنشاء ملف Excel للفترة من {p}.",
      inProgressFile: "جاري إنشاء الملف:",
      willSendToEmail: "ملف تفاصيل ميزان المراجعة قيد الإنشاء وسيتم إرساله إلى {email} عند الانتهاء.",
      csvOptionDownload: "للفترات التي تزيد عن شهر، يرجى استخدام تحميل CSV.",
      rowLimitExceeded: "This range has {rows} ledger entries (max {max}). Narrow the date range or use the CSV download.",
    },
    purchaseReceivingDetail: {
      generatingData: "جاري إنشاء تفاصيل تقرير الاستلام. يرجى الانتظار؛ قد يستغرق ذلك بعض الوقت. يمكنك إغلاق النافذة أو الانتقال لصفحة أخرى؛ ستستمر العملية.",
      readyForDownload: "ملف تفاصيل تقرير الاستلام متاح الآن للتنزيل: ",
      sendEmail: "وإرسال إلى البريد الإلكتروني:",
      exclusiveDownload: "نتائج تقرير الاستلام التفصيلية غير متاحة للعرض على الويب ويمكن الوصول إليها فقط من خلال تنزيل الملف. <br> للمجموعات التي تحتوي على أكثر من 5,000 صف، يرجى استخدام خيار تنزيل Excel.",
      gsheeRowLimitExceeded: "تم تجاوز حد الصفوف في Google Sheets. يرجى تنزيل الملف كوثيقة Excel.",
    },
    commonReportDetail: {
      generatingData: "جاري إنشاء تفاصيل {f1}. يرجى الانتظار؛ قد يستغرق ذلك بعض الوقت. يمكنك إغلاق النافذة أو الانتقال لصفحة أخرى؛ ستستمر العملية.",
      readyForDownload: "ملف تفاصيل {f1} متاح الآن للتنزيل: ",
      sendEmail: "وإرسال إلى البريد الإلكتروني:",
      exclusiveDownload: "نتائج {f1} التفصيلية غير متاحة للعرض على الويب ويمكن الوصول إليها فقط من خلال تنزيل الملف. <br> للمجموعات التي تحتوي على أكثر من {f2} صف، يرجى استخدام خيار تنزيل Excel.",
      gSheetRowLimitExceeded: "تم تجاوز حد الصفوف في Google Sheets. يرجى تنزيل الملف كوثيقة Excel.",
    },
    disabledDueToQuantityReceived: "تم التعطيل بسبب وجود كمية مستلمة",
    exclusiveDownload: "النتائج التفصيلية غير متاحة للعرض على الويب. يرجى استخدام خيار التنزيل لعرض التفاصيل الكاملة.",
    willSendToEmail: "الملف قيد الإنشاء وسيتم إرساله إلى {email} عند الانتهاء.",
  },
  confirm: {
    processing: "جاري المعالجة، يرجى الانتظار",
    noAccess: "لا يوجد وصول",
    correctionTitle: "تصحيح تطبيق ثابت",
    correction: "هل أنت متأكد من إجراء التصحيح لـ {f}",
    receiveAllHeader: "تعيين استلام الكل",
    receiveAll: "تعيين استلام كل الكمية؟",
    receiveAllFailed: "فشل تعيين استلام الكل",
    noEntryPreviewPost: "لم يتم إنشاء أي قيود لهذا الترحيل",
    deleteHeader: "حذف {f}",
    deleteCanUndo: "هل أنت متأكد أنك تريد حذف {f}؟",
    delete: "هل أنت متأكد أنك تريد حذف {f}؟ لا يمكن التراجع عن هذه العملية.",
    deleteBatch: "هل أنت متأكد أنك تريد حذف {f1} صفوف من {f2}؟ لا يمكن التراجع عن هذه العملية.",
    deleteSuccess: "تم حذف {f} بنجاح!",
    deleteFailed: "خطأ، لا يمكن حذف {f}.",
    updateSuccess: "تم حفظ {f} بنجاح!",
    updateFailed: "خطأ، لا يمكن حفظ {f}.",
    printFailed: "خطأ، لا يمكن طباعة {f}.",
    importSuccess: "تم استيراد {f} بنجاح!",
    importFailed: "خطأ، لا يمكن استيراد {f}.",
    dialogClosing: "يتم إغلاق الحوار",
    releaseSuccess: "تم إصدار {f} بنجاح!",
    releaseFailed: "خطأ، لا يمكن إصدار {f}.",
    reopenSuccess: "تم إعادة فتح {f} بنجاح!",
    reopenFailed: "خطأ، لا يمكن إعادة فتح {f}.",
    reopenFailedAlreadyProcessed: "خطأ، لا يمكن إعادة فتح {f}. الطلب تم استلامه بالفعل",
    closeSuccess: "{f} تم إغلاقه بنجاح!",
    closeFailed: "خطأ، لا يمكن إغلاق {f}.",
    restore: "هل أنت متأكد أنك تريد استعادة {f}؟",
    restoreHeader: "استعادة {f}",
    restoreFailed: "خطأ، لا يمكن استعادة {f}.",
    restoreSuccess: "تم استعادة \"{f}\" بنجاح!",
    setToNonDirectExpense: "هل أنت متأكد أنك تريد تعيينه كنفقات غير مباشرة {f}؟",
    setToNonDirectExpenseHeader: "تعيين كنفقات غير مباشرة {f}",
    setToNonDirectExpenseFailed: "خطأ، لا يمكن تعيينه كمصروف غير مباشر {f}.",
    setToNonDirectExpenseSuccess: "تم تعيين \"{f}\" كمصروف غير مباشر بنجاح!",
    applyEntriesSuccess: "تم تطبيق الإدخالات بنجاح!",
    applyEntriesFailed: "خطأ، فشل في تطبيق الإدخالات {f}.",
    unapplyEntriesSuccess: "تم إلغاء تطبيق الإدخالات بنجاح!",
    unapplyEntriesFailed: "خطأ، فشل في إلغاء تطبيق الإدخالات {f}.",
    reverseEntriesSuccess: "تم عكس الإدخالات بنجاح!",
    reverseEntriesFailed: "خطأ، فشل في عكس الإدخالات {f}.",
    postedSuccess: "تم نشر \"{f}\" بنجاح!",
    postedFailed: "خطأ، لا يمكن نشر {f}.",
    postedFailedUnitCostZero: "خطأ، لا يمكن نشر {f}. تكلفة الوحدة لا يمكن أن تكون 0.",
    postHaveNegativeAdjustment: "تحذير، النشر سيضيف تعديل سلبي. هل تريد المتابعة؟",
    processSuccess: "تمت معالجة \"{f}\" بنجاح!",
    processedItems: "- {f1} ({f2})، الكمية {f3} {f4}",
    processAlready: "تمت معالجة هذه العناصر كطلب شراء:<br/>{f}",
    hasZeroUnitCost: "بعض العناصر لا تحتوي على تكلفة وحدة. يرجى التحقق مرة أخرى!",
    hasZeroQuantity: "بعض العناصر كمية صفر. يرجى التحقق مرة أخرى!",
    hasZeroStockOnHand: "بعض العناصر ليس لديها مخزون. يرجى التحقق مرة أخرى!",
    hasQtyGreatedThanStockOnHand: "بعض العناصر لديها كمية أكبر من المخزون المتوفر. يرجى التحقق مرة أخرى!",
    rejectHeader: "رفض {f}",
    rejectAlready: "تم رفض هذه العنصر(العناصر):<br/>{f}",
    reject: "هل أنت متأكد أنك تريد رفض {f}؟<br/>لا يمكن التراجع عن هذه العملية.",
    splitHeader: "قسّم {f}",
    splitSuccess: "تم تقسيم العنصر بنجاح!",
    splitFailed: "خطأ، لا يمكن تقسيم العنصر.<br/>{f}",
    splitMultipleFailed: "خطأ، لا يمكن تقسيم أكثر من عنصر واحد.",
    setVendorSuccess: "تم تحديث \"{f}\" بنجاح!",
    cancelReceipt: "هل أنت متأكد أنك تريد إلغاء الإيصال {f}؟ لا يمكن التراجع عن هذه العملية.",
    cancelReceiptSuccess: "تم إلغاء \"{f}\" بنجاح!",
    cancelReceiptFailed: "خطأ، لا يمكن إلغاء {f}.",
    cancelReceiptHeader: "إلغاء الإيصال {f}",
    undoReceipt: "هل أنت متأكد أنك تريد التراجع عن الإيصال {f}؟ لا يمكن التراجع عن هذه العملية.",
    undoReceiptSuccess: "تم التراجع عن {f} بنجاح!",
    undoReceiptFailed: "خطأ، لا يمكن التراجع عن {f}.",
    undoReceiptHeader: "تراجع عن الإيصال {f}",
    forceCloseHeader: "إغلاق قسري {f}",
    forceClose: "هل أنت متأكد أنك تريد إغلاق {f1} صفوف من {f2}؟ لا يمكن التراجع عن هذه العملية.",
    addfromReceiptSuccess: "تم إضافة \"{f}\" بنجاح مع العثور على {d} مكرر",
    incompleteSearch: "{f} بحاجة إلى تحديد الموقع أو فلتر العنصر",
    postedFailedNoItems: "خطأ، لا يمكن نشر {f}. يجب أن يكون لديك على الأقل عنصر واحد ليتم استلامه.",
    postFailedNoItems: "خطأ، لا يمكن نشر {f}. يجب أن يحتوي المستند على عنصر واحد على الأقل.",
    updateFailedOnUnitEmpty: "خطأ، لا يمكن حفظ {f1}.<br/>لا توجد وحدة قياس لهذه العناصر:<br/>{f2}",
    printFailedNoActiveFlow: "خطأ، لا يمكن طباعة هذا المستند.<br/>لا يوجد تدفق مستند نشط مكون في الدفعة {f}.",
    deleteFailedAlreadyReleased: "خطأ، لا يمكن حذف {f}.<br/>تم إصدار هذا المستند بالفعل.",
    processToPoFailedOnVendorEmpty: "لا يمكن متابعة عملية طلب الشراء. يرجى ملء طلب الشراء بالكامل.",
    invalidAmount: "خطأ، مبلغ غير صالح لتقديم الإدخالات",
    postedFailedNoItemsOnTable: "خطأ، لا يمكن نشر الدفعة {f}. يجب أن تحتوي على مستند واحد على الأقل.",
    postBatchCompleted: "تم إكمال دفعة النشر!",
    failedDocumentToPost: "فشل نشر بعض الوثائق:<br/>{f}",
    deleteAllSelected: "هل أنت متأكد أنك تريد حذف جميع العناصر المحددة؟ لا يمكن التراجع عن هذه العملية.",
    deleteFailedNoItemsSelected: "خطأ، لا يمكن حذف {f}. يجب أن يكون هناك عنصر واحد على الأقل محدد في الجدول.",
    deleteFailedNoItems: "خطأ، لا يمكن حذف {f}. يجب أن يكون هناك عنصر واحد على الأقل في الجدول.",
    setVendorFailedNoItemsSelected: "خطأ، لا يمكن تعيين البائع. يجب أن يكون هناك عنصر واحد على الأقل محدد في الجدول.",
    deleteFailedForStatus: "خطأ، لا يمكن حذف {f1}. {f2} تم {f3} بالفعل.",
    deleteItemFailedForStatus: "خطأ، لا يمكن حذف العناصر. حالة العنصر قد تغيرت بالفعل.",
    processedItemsStatus: "- {f1} ({f2}) {f3} {f4} => <b>{f5}</b>",
    reopenFailedProcessedAlready: "تم معالجة بعض العناصر. لا يمكن إعادة فتحها!",
    postBatchConfirm: "هل أنت متأكد أنك تريد نشر جميع البيانات على الجدول؟",
    postSelectedConfirm: "هل أنت متأكد أنك تريد نشر المستند المحدد؟",
    noItemSelected: "خطأ، لم يتم اختيار عنصر",
    postSRFailedPostingDateLessThanDocumentDate: "خطأ، لا يمكن النشر {f}. تاريخ النشر لا يمكن أن يكون قبل تاريخ الوثيقة.",
    setAllQtyToZero: "هل أنت متأكد أنك تريد تعيين الكمية إلى صفر؟ لا يمكن التراجع عن هذه العملية.",
    updateLocationHeader: "تحديث موقع العنصر",
    updateLocation: "هل تريد تحديث جميع المواقع في السطر إلى {f}؟<br/>لا يمكن التراجع عن هذه العملية.",
    setLocationSuccess: "تم تحديث موقع العنصر بنجاح!",
    allQtyToZeroSuccess: "تم تعيين الكمية إلى صفر بنجاح!",
    allQtyToZeroFailed: "خطأ، لا يمكن تعيين الكمية إلى صفر!",
    refreshPhysInvUnitCost: "هل أنت متأكد أنك تريد تحديث جميع تكاليف الوحدات؟ لا يمكن التراجع عن هذه العملية.",
    refreshPhysInvUnitCostSuccess: "تم تحديث تكلفة الوحدة بنجاح!",
    refreshPhysInvUnitCostFailed: "خطأ، لا يمكن تحديث تكلفة الوحدة!",
    itemMassRecalculate: "هل أنت متأكد أنك تريد إعادة حساب تكلفة الوحدة لجميع العناصر المحددة؟ لا يمكن التراجع عن هذه العملية.",
    storeRequisitionRefreshUnitCost: "هل أنت متأكد أنك تريد إعادة حساب جميع العناصر وتحديث تكلفة الوحدة لجميع السطور في هذا المستند؟ لا يمكن التراجع عن هذه العملية.",
    revertPostedStoreRequisition: "هل أنت متأكد أنك تريد إلغاء طلب المتجر المنشور؟ ستؤدي هذه العملية إلى إزالة جميع الإدخالات المتعلقة بهذا المستند وستعيد SR إلى حالة الإصدار مرة أخرى. لا يمكن التراجع عن هذه العملية.",
    revertPostedStoreRequisitionSuccess: "تم إلغاء طلب المتجر المنشور بنجاح!",
    revertPostedStoreRequisitionFailed: "خطأ، لا يمكن إلغاء طلب المتجر المنشور!",
    deleteItemLedgerEntry: "هل أنت متأكد أنك تريد حذف سجل هذا العنصر؟ ستؤدي هذه العملية إلى إزالة جميع الإدخالات المتعلقة بهذا المستند. لا يمكن التراجع عن هذه العملية.",
    deleteItemLedgerEntrySuccess: "تم حذف سجل العنصر بنجاح!",
    deleteItemLedgerEntryFailed: "خطأ، لا يمكن حذف سجل العنصر!",
    deleteItemLedgerEntryTypeNotAllowed: "لا يُسمح بحذف هذا النوع من الإدخال.",
    itemMassRecalculateSuccess: "تم إعادة حساب تكلفة الوحدة بالكامل!",
    itemMassRecalculateFailed: "خطأ، فشل في إعادة حساب تكلفة الوحدة!",
    itemMassRecalculateNoData: "إعادة حساب العنصر لم تنفذ، لا توجد بيانات!",
    refreshUnitCostSuccess: "تم تحديث تكلفة الوحدة بالكامل!",
    refreshUnitCostFailed: "خطأ، لا يمكن تحديث تكلفة الوحدة!",
    itemTypeIsNotGl: "نوع العنصر غير مسموح به",
    withdrawHeader: "سحب {f}",
    withdraw: "هل أنت متأكد أنك تريد سحب {f}؟ لا يمكن التراجع عن هذه العملية.",
    withdrawSuccess: "تم سحب \"{f}\" بنجاح!",
    delegateSuccess: "تم تفويض \"{f}\" بنجاح!",
    delegate: "هل أنت متأكد أنك تريد تفويض <strong>{t}</strong> بالنيابة عن <strong>{f}</strong>؟ سيتم إبلاغ المستخدمين المعنيين.",
    delegateHeader: "فوّض {t}",
    viewReportFailedNoSetup: "لا يمكن عرض التقرير بسبب وجود إدخال مفقود في إعداد تسوية المخزون.<br/>يرجى إكمال جميع الإعدادات أولاً!",
    approvalSubmissionSuccess: "تم تقديم \"{f}\" بنجاح للموافقة!",
    closeIncomeStatementSuccess: "تم إنشاء قيود دفتر اليومية لبيان الدخل بنجاح. يرجى مراجعة الدفاتر المنشأة في الدفعة المحددة.",
    closeIncomeStatementFailed: "خطأ، فشل إنشاء سجل بيان الدخل",
    entryEditorSuccess: "تم تحديث الإدخال بنجاح!",
    removeApplyToJournalIdAndAmountToApplyWithId: "إزالة المجلة المطبقة على المعرف: {f}",
    removeApplyToJournalIdAndAmountToApplyFailed: "خطأ، لا يمكن إزالة {f}. لا يزال معرف السجل موجودًا.",
    removeApplyToJournalIdAndAmountToApplyErrorFailed: "خطأ، فشل في إزالة السجل المطبق",
    removeApplyToJournalIdAndAmountToApplyErrorCheckJournal: "خطأ، لا يمكن الإزالة بسبب خطأ في التحقق من السجل",
    removeApplyToJournalIAndAmountToApplydNotAllowed: "لا يُسمح بإزالة المجلة المطبقة",
    submitSuccess: "{f} تم تقديمه بنجاح!",
    withdrawDocument: "هل أنت متأكد أنك تريد سحب الوثيقة؟ لا يمكن التراجع عن هذه العملية.",
    adjustAllConfirmation: "هل أنت متأكد أنك تريد تعديل جميع العناصر؟<br/>لا يمكن التراجع عن هذه العملية.",
    adjustConfirmation: "هل أنت متأكد أنك تريد التعديل على العناصر المفلترة فقط؟<br/>لا يمكن التراجع عن هذه العملية.",
    viewReportFailedNoAccountSetup: "لا يمكن عرض التقرير. يجب أن يكون لديك حساب واحد على الأقل!",
    defaultDirectExpenseChanged: "تم تغيير المصروف المباشر الافتراضي",
    overwriteDirectExpenseLineConfirm: "هل تريد استبدال جميع الأسطر بالإعدادات الافتراضية الجديدة؟",
    existingLineRemovalConfirm: "سيتم إزالة الخط الحالي. هل أنت متأكد؟",
    undoForceCloseHeader: "تراجع عن الإغلاق القسري {f}",
    undoForceClose: "هل أنت متأكد أنك تريد التراجع عن إغلاق هذا العنصر بالقوة؟",
    undoForceCloseFailed: "لا يمكن التراجع، بعض العناصر لم تُغلق بالقوة بعد!",
    errorEmptyLines: "لا يمكن أن تكون الخطوط فارغة",
    failedGetSOHForItem: "خطأ، لا يمكن الحصول على المخزون المتوفر لهذا العنصر/السطر",
    invalidThresholdItems: "- {f1} ({f2})، تكلفة الوحدة {f3} مع آخر تكلفة مباشرة {f4}",
    filteringWillBeReleased: "سيتم إزالة جميع شروط التصفية، وبالتالي سيتم معالجة جميع العناصر. هل أنت متأكد؟",
    areYouSure: "هل أنت متأكد؟",
    setToCompletelyReceivedConfirmation: "هل أنت متأكد أنك تريد تعيين هذا كمستلم بالكامل؟",
    unsetCompletelyReceivedConfirmation: "هل أنت متأكد أنك تريد إلغاء الاستلام بالكامل؟",
    confirmAction: "تأكيد الإجراء",
    areYouSureToAction: "هل أنت متأكد أنك تريد {action}؟",
    costsUpdated: "تم تحديث تكاليف العناصر بنجاح!",
    costsUpdateFailed: "خطأ، لا يمكن تحديث تكاليف العناصر.",
    incorrectCostsWarning: "العناصر التالية لديها تكاليف وحدات تختلف عن تكاليف المخزون المتاحة. يمكنك إما إلغاء أو تحديث جميع تكاليف الوحدات تلقائيًا.",
    incorrectCostsTitle: "عناصر بتكاليف غير صحيحة",
    incorrectCostsContinueAnyway: "استمر على أي حال",
    incorrectCostsUpdate: "تحديث تكلفة الوحدة",
    incorrectCostsItemCode: "رمز العنصر",
    incorrectCostsLocation: "الموقع",
    incorrectCostsCurrentUnitCost: "تكلفة الوحدة الحالية",
    incorrectCostsStockOnHandCost: "تكلفة المخزون المتوفر",
    incorrectCostsDifference: "فرق",
    incorrectCostsStockOnHand: "المخزون المتوفر",
    confirmDelete: "هل أنت متأكد أنك تريد حذف هذا {f}؟",
    confirmDeleteMultiple: "هل أنت متأكد أنك تريد حذف هذه {f}؟",
    setVatFailedNoItemsSelected: "خطأ، لا يمكن تعيين ضريبة القيمة المضافة. يجب أن يكون هناك عنصر واحد على الأقل محدد في الجدول.",
    confirmUpdate: "هل أنت متأكد أنك تريد تحديث هذا {f}؟",
    postSelectedConfirmWithCount: "هل أنت متأكد أنك تريد نشر {v} مستندات مختارة؟",
    confirmSendEmail: "هل أنت متأكد أنك تريد إرسال رسائل البريد الإلكتروني للفواتير المحددة؟",
    updatePurchaseOrderStatusConfirmation: "هل أنت متأكد أنك تريد تغيير الحالة من '{f1}' إلى '{f2}'؟",
    updatePurchaseOrderStatusConfirmationWithDoc: "هل أنت متأكد أنك تريد تغيير حالة أمر الشراء '{f1}' من '{f2}' إلى '{f3}'؟",
    updateUnitCostVendorComparisonLowestSuccess: "{f} تم تحديثه بأقل سعر باستخدام مقارنة الموردين!",
    updateUnitCostVendorComparisonLowestFailed: "خطأ، لا يمكن تحديث تكلفة الوحدة باستخدام سعر مقارنة المورد (الأدنى).",
    successRecalculateInventory: "تم إعادة حساب سجل الجرد الفعلي!",
    failedRecalculateInventory: "خطأ، لا يمكن إعادة حساب سجل الجرد الفعلي.",
    revertSuccess: "تم التراجع عن \"{f}\" بنجاح!",
    revertFailed: "خطأ، لا يمكن التراجع عن {f}.",
    dimensionBulkImportSuccess: "تم إضافة {dimensions} أبعاد، {values} قيم",
    coaDimensionBulkImportSuccess: "تم إضافة {mappings} تعيين، {rules} قاعدة",
    updateCoaDimensionMappingConfirmation: "هل أنت متأكد أنك تريد تحديث هذا التعيين؟",
    downloadFailedActiveFlowIsEmpty: "خطأ، لا يمكن تنزيل هذا المستند.<br/>تدفق المستند النشط الحالي غير مُهيأ أو لا يزال فارغًا.",
    calculateInventoryFilterWarning: "إذا تم استخدام الفلتر أدناه، ستقوم حسابات المخزون بإنشاء إدخال جديد بدلاً من الكتابة فوق الإدخال الحالي.",
    processExpiredWarning: "هل أنت متأكد أنك تريد انتهاء الإدخالات القديمة؟ سيتم وضع علامة على الإدخالات التي تزيد عن {x} على أنها منتهية. يمكن التراجع عن هذا الإجراء، ولكن يدويًا لكل إدخال.",
    forceCloseWarning: "هل أنت متأكد أنك تريد إغلاق الإدخالات القديمة؟ سيتم إغلاق جميع الإدخالات التي تزيد عن {x} بشكل دائم. لا يمكن التراجع عن هذا الإجراء.",
    revertExpiredWarning: "هل أنت متأكد أنك تريد استرجاع الإدخالات المنتهية؟",
    addfromReceiptRejected: "{f} خط(وط) مرفوضة: {m}",
    postPositiveAdjustmentNotAllowed: "لا يمكن النشر: التعديل الإيجابي غير مسموح لـ {f}.",
  },
  data: {
    clientLedgerEntryId: "معرف قيد دفتر العميل",
    vendorLedgerEntryId: "معرف قيد دفتر المورد",
    isReconciled: "هل تمت المطابقة؟",
    isCloseYearEntry: "قيد إغلاق السنة؟",
    stockOnHand: "المخزون المتوفر",
    inputStockOnHand: "إدخال المخزون المتوفر",
    inputStockOnHandFrom: "إدخال المخزون المتوفر (من)",
    inputStockOnHandTo: "إدخال المخزون المتوفر (إلى)",
    stockOnHandFrom: "المخزون المتوفر (من)",
    stockOnHandTo: "المخزون المتوفر (إلى)",
    reconciliationGlAccount: "حساب الأستاذ العام للتسوية",
    virtualAccount: "حساب افتراضي",
    accountName: "اسم الحساب",
    accountNameList: "قائمة أسماء الحسابات",
    accountNumber: "رقم الحساب",
    bankAccountPostingGroupCode: "رمز مجموعة ترحيل الحساب البنكي",
    bankAccountPostingGroupName: "اسم مجموعة ترحيل الحساب البنكي",
    reconciliationAccount: "حساب التسوية",
    reconciliationBankAccount: "حساب بنكي للتسوية",
    isReconciliationAccount: "هل هو حساب تسوية؟",
    showOppositeSigninReport: "عرض الإشارة المعاكسة في التقرير",
    setWidenedPhysicalInventoryRow: "تعيين صف الجرد الفعلي الموسع",
    itemVendorPurchaseprice: "سعر شراء الصنف من المورد",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    startDateWithPlaceholderDDMMYYYY: "تاريخ البدء (DD-MM-YYYY)",
    endDateWithPlaceholderDDMMYYYY: "تاريخ الانتهاء (DD-MM-YYYY)",
    purchasePrice: "سعر الشراء",
    year: "السنة",
    lastIleId: "معرف ILE الأخير",
    inventoryPostingType: "نوع ترحيل المخزون",
    isFlashCostStoreRequisition: "هل هو تكلفة سريعة لطلب المتجر؟",
    isFlashCostPurchaseRequisition: "هل هو تكلفة سريعة لطلب الشراء؟",
    requestStatus: "حالة الطلب",
    receiptStatus: "حالة الاستلام",
    created: "تم الإنشاء",
    createdBy: "تم الإنشاء بواسطة",
    createdAt: "تاريخ الإنشاء",
    lastModified: "آخر تعديل",
    lastModifiedBy: "تم التعديل بواسطة",
    swiftCode: "رمز SWIFT",
    defaultBank: "البنك الافتراضي",
    destinationName: "اسم الوجهة",
    destinationID: "معرف الوجهة",
    department: "القسم",
    clientInfo: "معلومات العميل",
    clientCode: "رمز العميل",
    clientName: "اسم العميل",
    clientId: "معرف العميل",
    guestName: "اسم الضيف",
    appliedVendorLedgerEntryId: "معرف القيد المطبق في دفتر المورد",
    appliedClientLedgerEntryId: "معرف القيد المطبق في دفتر العميل",
    appliedBankAccountLedgerEntryId: "معرف القيد المطبق في دفتر الحساب البنكي",
    defaultGuestInhouseAccountId: "معرف حساب الضيف الافتراضي",
    isReceivedCompletely: "تم الاستلام بالكامل",
    termCode: "رمز الشرط",
    termName: "اسم الشرط",
    searchBar: "ابحث هنا...",
    netChange: "صافي التغيير",
    entry: "قيد",
    totalDocument: "إجمالي المستندات",
    vendorCode: "رمز المورد",
    vendorName: "اسم المورد",
    itemCode: "رمز الصنف",
    itemName: "اسم الصنف",
    itemID: "معرف الصنف",
    itemTypeName: "اسم نوع الصنف",
    itemTypeID: "معرف نوع الصنف",
    itemDescription: "وصف الصنف",
    itemUnitCost: "تكلفة وحدة الصنف",
    vatAmount: "قيمة ضريبة القيمة المضافة",
    autoRecalculateCost: "إعادة حساب التكلفة تلقائيًا",
    step: "خطوة",
    allowMultiple: "السماح بعدة خيارات",
    posting: "ترحيل",
    invoice: "فاتورة",
    receipt: "إيصال",
    receiptPosting: "ترحيل الإيصال",
    order: "طلب",
    wording: "صياغة",
    defaultName: "الاسم الافتراضي",
    defaultRoleName: "اسم الدور الافتراضي",
    role: "الدور",
    defaultVatProductPostingGroup: "مجموعة ترحيل ضريبة القيمة المضافة الافتراضية للمنتجات",
    conversion: "تحويل",
    email: "البريد الإلكتروني",
    accountNo: "رقم الحساب",
    glAccount: "الحساب العام",
    location: "الموقع",
    offsetLocation: "موقع الإزاحة",
    defaultFromLocation: "الموقع الافتراضي (من)",
    defaultToLocation: "الموقع الافتراضي (إلى)",
    invPostGroup: "مجموعة ترحيل المخزون",
    accountCode: "رمز الحساب",
    interimAccountName: "اسم الحساب المؤقت",
    interimAccountNo: "رقم الحساب المؤقت",
    purchaseAccount: "حساب الشراء",
    accrualInterimAccount: "حساب مؤقت للتسويات",
    inventoryAdjustmentAccount: "حساب تسوية المخزون",
    expenseInventoryAdjustmentAccount: "حساب مصروفات تسوية المخزون",
    directCostAppliedAccount: "حساب التكاليف المباشرة المطبقة",
    vatBusPostGroup: "مجموعة ترحيل ضريبة القيمة المضافة للأعمال",
    vatBusPostGroupCode: "رمز مجموعة ترحيل ضريبة القيمة المضافة للأعمال",
    vatBusPostGroupID: "معرف مجموعة ترحيل ضريبة القيمة المضافة للأعمال",
    vatProductPostingGroup: "مجموعة ترحيل ضريبة القيمة المضافة للمنتجات",
    vatProductPostingGroupID: "معرف مجموعة ترحيل ضريبة القيمة المضافة للمنتجات",
    whtVatProductPostingGroup: "مجموعة ترحيل ضريبة القيمة المضافة المقتطعة",
    genBusPostGroup: "مجموعة ترحيل الأعمال العامة",
    genBusPostGroupCode: "رمز مجموعة ترحيل الأعمال العامة",
    genBusPostGroupID: "معرف مجموعة ترحيل الأعمال العامة",
    genProdPostGroup: "مجموعة ترحيل المنتجات العامة",
    genProdPostGroupID: "معرف مجموعة ترحيل المنتجات العامة",
    bankAccPostGroup: "مجموعة ترحيل الحسابات البنكية",
    documentType: "نوع المستند",
    documentNo: "رقم المستند",
    batch: "دفعة",
    description: "الوصف",
    postingDate: "تاريخ الترحيل",
    expectedDate: "تاريخ متوقع",
    debitAmount: "مبلغ مدين",
    creditAmount: "مبلغ دائن",
    amount: "المبلغ",
    isApplied: "تم التطبيق",
    appliedSalesInvoiceId: "معرف فاتورة المبيعات المطبقة",
    appliedSalesCreditMemoId: "معرف إشعار الدائن للمبيعات المطبق",
    cashDeskMovementId: "معرف حركة الصندوق",
    no: "لا",
    code: "رمز",
    name: "اسم",
    glAccountNo: "رقم حساب دفتر الأستاذ",
    paymentTerm: "شروط الدفع",
    directExpenseGenBusPostGroup: "مجموعة مصروفات مباشرة",
    directExpenseGenProdPostGroup: "مجموعة مصروفات مباشرة للمنتجات",
    directExpenseAdjustmentAccount: "حساب تعديل المصروفات المباشرة",
    defaultDirectExpenseGenBusPostGroup: "مجموعة مصروفات مباشرة افتراضية",
    custPostGroup: "مجموعة نشر العميل",
    vendorPostGroup: "مجموعة نشر المورد",
    journalTemplate: "قالب يومية",
    journalTemplateId: "معرف قالب دفتر اليومية",
    journalBatchId: "معرف دفعة دفتر اليومية",
    revenueLineId: "معرف خط الإيراد",
    noSeries: "لا توجد سلسلة",
    defaultLocation: "الموقع الافتراضي",
    prefix: "بادئة",
    startingNumber: "رقم البداية",
    lastNumberUsed: "آخر رقم مستخدم",
    lengthOfNumber: "طول الرقم",
    includeYear: "تضمين السنة",
    includeMonth: "شمل الشهر",
    includeDate: "تضمين التاريخ",
    isEditable: "قابل للتعديل",
    branch: "فرع",
    bankAccountNo: "رقم الحساب البنكي",
    virtualAccountNo: "رقم الحساب الافتراضي",
    allowPostingFrom: "السماح بالنشر من",
    allowPostingTo: "السماح بالنشر إلى",
    receivableAccount: "حساب مستحقات",
    receivableAccountNo: "رقم حساب المدين",
    payableAccount: "حساب مستحق الدفع",
    balanceAccount: "رصيد الحساب",
    accountCategory: "فئة الحساب",
    accountType: "نوع الحساب",
    directPost: "البريد المباشر",
    blocked: "محظور",
    vatPercentage: "نسبة الضريبة المضافة",
    startingDate: "تاريخ البدء",
    closed: "مغلق",
    endingDate: "تاريخ الانتهاء",
    dueDateCalc: "حساب تاريخ الاستحقاق",
    address: "العنوان",
    city: "مدينة",
    country: "الدولة",
    phoneNo: "رقم الهاتف",
    contactName: "اسم جهة الاتصال",
    unit: "وحدة",
    costingMethod: "طريقة التكلفة",
    unitCost: "تكلفة الوحدة",
    baseUnitCost: "تكلفة الوحدة الأساسية",
    inputUnitCost: "تكلفة الوحدة المدخلة",
    lastDirectCost: "آخر تكلفة مباشرة",
    reorderQuantity: "كمية إعادة الطلب",
    totalling: "إجمالي",
    totallingFrom: "الإجمالي من",
    totallingTo: "الإجمالي إلى",
    directPosting: "نشر مباشر",
    batchName: "اسم الدفعة",
    lineNo: "رقم الخط",
    inventory: "المخزون",
    vendorAccount: "حساب البائع",
    clientAccount: "حساب العميل",
    totalAmount: "المبلغ الإجمالي",
    selectedTotalAmount: "المبلغ الإجمالي المحدد",
    status: "الحالة",
    purchasingStatus: "حالة الشراء",
    quantity: "الكمية",
    value: "القيمة",
    inputQuantity: "أدخل الكمية",
    inputUom: "وحدة القياس المدخلة",
    forceCloseReason: "سبب الإغلاق القسري",
    unitPrice: "سعر الوحدة",
    totalPrice: "السعر الإجمالي",
    closedByUser: "أغلق بواسطة المستخدم",
    includeAutoClosed: "تضمين الإغلاق التلقائي",
    baseQuantity: "الكمية الأساسية",
    id: "معرّف",
    orderDate: "تاريخ الطلب",
    amountIncVat: "المبلغ شامل ضريبة القيمة المضافة",
    amountExcVat: "المبلغ بدون ضريبة القيمة المضافة",
    unitCostIncVat: "تكلفة الوحدة شاملة ضريبة القيمة المضافة",
    itemNo: "رقم العنصر",
    purchaseRequestNo: "رقم الطلب",
    purchaseOrderNo: "رقم الطلب",
    deliveryDate: "تاريخ التسليم",
    quantityOutstanding: "الكمية المتبقية",
    type: "اكتب",
    balance: "رصيد",
    balanceToDate: "الرصيد حتى اليوم",
    subTotal: "المجموع الفرعي",
    vat: "ضريبة القيمة المضافة",
    totalIncVat: "الإجمالي شامل ضريبة القيمة المضافة",
    vendorDeliveryNo: "رقم توصيل البائع",
    poNo: "رقم الطلب",
    salesTaxAccount: "حساب ضريبة المبيعات",
    purchaseTaxAccount: "حساب ضريبة الشراء",
    total: "الإجمالي",
    totalRows: "إجمالي الصفوف:",
    purchaseRequestSeries: "سلسلة طلب الشراء",
    purchaseOrderSeries: "سلسلة أوامر الشراء",
    purchaseReceiptSeries: "سلسلة إيصالات الشراء",
    purchaseInvoiceSeries: "سلسلة فواتير الشراء",
    purchaseInvoiceLabel: "فاتورة الشراء",
    purchaseReceiptLabel: "إيصال الشراء",
    purchaseCreditMemoSeries: "شراء سلسلة الرصيد",
    salesInvoiceSeries: "سلسلة فواتير المبيعات",
    salesCreditMemoSeries: "سلسلة ائتمان المبيعات",
    receivableInvoiceSeries: "سلسلة فواتير مستحقة",
    symbol: "رمز",
    transferOrderSeries: "سلسلة أوامر النقل",
    defaultCostingMethod: "طريقة التكلفة الافتراضية",
    quantityReceived: "الكمية المستلمة",
    quantityInvoiced: "الكمية المفوترة",
    quantityPO: "الكمية المطلوبة",
    quantityToReceive: "الكمية المستلمة",
    quantityOrdered: "الكمية المطلوبة",
    purchaseReceivingList: "قائمة تاريخ إيصالات الشراء",
    quantityToInvoice: "الكمية للفوترة",
    prNumber: "رقم طلب الشراء",
    vendorOneName: "البائع 1",
    vendorOnePrice: "السعر 1",
    vendorTwoName: "البائع 2",
    vendorTwoPrice: "السعر 2",
    vendorThreeName: "البائع 3",
    vendorThreePrice: "السعر 3",
    showVendorColumns: "عرض عمود مقارنة الموردين",
    showVendorDetail: "عرض البائع",
    showSOHByInputUOM: "عرض المخزون المتوفر بوحدة الإدخال",
    showByInputUOM: "عرض حسب وحدة الإدخال",
    expirationDate: "تاريخ الانتهاء",
    vendorInvoiceNo: "رقم فاتورة المورد",
    receiptNo: "رقم الإيصال",
    invoiceNo: "رقم الفاتورة",
    sourcePurchaseInvoice: "فاتورة الشراء المصدر",
    targetPurchaseInvoice: "فاتورة الشراء الهدف",
    movePreview: "معاينة النقل",
    from: "من",
    to: "إلى",
    dueDate: "تاريخ الاستحقاق",
    documentFlow: "تدفق المستند النشط",
    receivableInvoiceDocumentFlow: "سير الوثائق النشطة للفواتير المستحقة",
    quantityToBeReceive: "المتبقي للاستلام",
    detail: "تفاصيل",
    purchaseRequisitionTemplate: "نموذج طلب شراء",
    entryType: "نوع الإدخال",
    invoicedQuantity: "الكمية المفوترة",
    ileQuantity: "كمية ILE",
    ileBaseQuantity: "الكمية الأساسية لـ ILE",
    remainingQuantity: "الكمية المتبقية",
    remainingQuantityToInvoice: "المتبقي للفوترة",
    outboundIle: "خارج ILE",
    inboundIle: "الوارد ILE",
    costAmountExpected: "المبلغ المتوقع",
    costAmountActual: "مبلغ التكلفة الفعلي",
    valuationDate: "تاريخ التقييم",
    averageCostEntryType: "نوع إدخال التكلفة المتوسطة",
    glRegisterId: "معرّف تسجيل GL",
    sourceIdtDocumentNo: "رقم مستند IDT المصدر",
    reconciledGlRegisterId: "تم التسوية بواسطة معرف سجل GL",
    isAdjustment: "تعديل",
    valuedQuantity: "الكمية القيمة",
    applyToEntry: "تقديم إلى رقم الدخول",
    fixedApply: "تطبيق ثابت",
    removeApplyToJournalIdAndAmountToApply: "إزالة المجلة المطبقة",
    applyToJournalIdAndAmountToApply: "تقديم على معرف المجلة والمبلغ المطلوب",
    applyToJournalId: "تقديم إلى معرف المجلة",
    amountToApply: "المبلغ للتطبيق",
    applied: "تم التقديم",
    invoiceDate: "تاريخ الفاتورة",
    remainingAmount: "المبلغ المتبقي",
    remainingAmountIncVat: "المبلغ المتبقي شامل ضريبة القيمة المضافة",
    unapplied: "غير مطبق",
    unappliedById: "غير مطبق بواسطة المعرف",
    currencyCode: "رمز العملة",
    reversed: "معكوس",
    reversedBy: "تم عكسه بواسطة",
    open: "فتح",
    vendorInfo: "معلومات البائع",
    itemNotOnInventory: "العنصر غير موجود في المخزون",
    dateFilterStart: "تاريخ البدء",
    dateFilterEnd: "تاريخ الانتهاء",
    dateFilter: "فلتر التاريخ",
    locationFilter: "فلتر الموقع",
    batchFilter: "فلتر الدفعة",
    itemFilter: "فلتر العناصر",
    quantityPhysicalInventory: "الكمية (الجرد الفعلي)",
    quantityCalculated: "الكمية (محسوبة)",
    documentDate: "تاريخ الوثيقة",
    requestByUser: "مطلوب من",
    fromLocation: "من",
    toLocation: "إلى",
    postingUser: "تم النشر بواسطة",
    posted: "تم النشر",
    isPosted: "تم النشر",
    quantityShipped: "الكمية المشحونة",
    baseQuantityShipped: "الكمية المشحونة الأساسية",
    locationCode: "رمز الموقع",
    locationName: "اسم الموقع",
    chartOfAccountDetail: "تفاصيل حسابات",
    taxType: "نوع الضريبة",
    notAvailable: "غير متوفر",
    notApplicable: "غير متوفر",
    appliesToPostedSalesInvoiceId: "رقم فاتورة المبيعات المطبقة",
    appliesToPostedPurchaseInvoiceId: "رقم فاتورة الشراء المطبقة",
    appliesToPostedSalesCreditMemoId: "رقم مذكرة ائتمان المبيعات المعتمدة",
    isForceClosed: "هل تم الإغلاق بالقوة",
    monthClosed: "تم إغلاق الشهر",
    yearClosed: "سنة مغلقة",
    inventoryClosed: "تم إغلاق المخزون",
    createYear: "محدد لسنة",
    includeIncome: "تضمين قيد الإغلاق",
    retainedEarningAccount: "حساب الأرباح المحتجزة",
    closeIncomeStatementJournalBatch: "إغلاق دفعة بيان الدخل",
    witholdingTaxDefaultJournalBatch: "دفعة سجل ضريبة الاستقطاع الافتراضية",
    showQuantityCalculated: "عرض عمود الكمية (محسوبة)",
    showQuantityAdjusted: "عرض عمود الكمية (المعدلة)",
    showAgedColumn: "عرض عمود العمر",
    showAgingDays: "عرض أيام التقدم في العمر",
    coaApInterim: "مؤقت COA AP",
    originalQuantity: "الكمية الأصلية",
    splitQuantity: "الكمية المراد تقسيمها",
    appliesToInvoiceNo: "ينطبق على فاتورة الشراء المنشورة",
    appliesToSalesInvoiceNo: "ينطبق على فاتورة المبيعات المنشورة",
    vendorId: "معرّف البائع",
    itemJournalMasterTemplate: "نموذج سجل العناصر",
    generalJournalMasterTemplate: "نموذج دفتر اليومية العام",
    checkIn: "تسجيل الوصول",
    checkOut: "الدفع",
    night: "ليل",
    roomNo: "رقم الغرفة",
    receivableInvoiceFooter: "تذييل فاتورة مستحقة",
    receivableInvoiceHeader: "رأس فاتورة مستحقة",
    allowBiggerQuantityInPurchaseOrder: "السماح بكمية أكبر في طلب الشراء",
    defaultPrintPOGroupLocation: "افتراضي مجمع حسب الموقع عند طباعة أمر الشراء",
    footerAutoColumn: "عمود التذييل التلقائي",
    allowAddNewItemInPOFromPR: "السماح بإضافة عنصر جديد في طلب الشراء من طلب الشراء",
    allowFlexibleItemInPO: "السماح بالمرونة في عناصر الطلب (يدوي وعناصر الشراء)",
    allowChangePriceWhenPOIsReleased: "السماح بتغيير السعر عند إصدار طلب الشراء",
    useCompanyNameForPrintout: "استخدم الاسم القانوني للشركة في رأس الطباعة",
    useBrandHotelNameForPrintout: "استخدم اسم الفندق في رأس الطباعة",
    purchaseOrderFooter: "تذييل طلب الشراء",
    customFooterPurchaseOrderText: "نص تذييل طلب الشراء المخصص",
    customFooterPurchaseRequestText: "نص تذييل طلب الشراء المخصص",
    customFooterPurchaseInvoiceText: "نص تذييل فاتورة الشراء المخصص",
    customFooterPurchaseReceiptText: "نص تذييل إيصال الشراء المخصص",
    customFooterStoreRequisitionText: "نص تذييل طلب المتجر المخصص",
    lastPrice: "السعر الأخير",
    baseLastPrice: "سعر الأساس الأخير",
    defaultFOCashDesk: "خزينة النقد الافتراضية",
    defaultFOCollectionType: "نوع مجموعة FO الافتراضي",
    documentTitle: "عنوان الوثيقة",
    startPostingDate: "تاريخ بدء النشر",
    endPostingDate: "تاريخ انتهاء النشر",
    allVendors: "جميع البائعين",
    allGroups: "جميع المجموعات",
    inventoryGroup: "مجموعة المخزون",
    noteCurrency: "ملاحظة: العملة المستخدمة في هذا التقرير هي {f}",
    otaBookingId: "رقم حجز OTA",
    otaBookingClientPostingGroup: "مجموعة نشر العميل لعرض معرف حجز OTA",
    show: "عرض",
    all: "الكل",
    fromAccount: "من الحساب",
    toAccount: "إلى الحساب",
    noteAccountFromTo: "ملاحظة: سيتم تصفية هذا التقرير من الحساب <strong>{f1}</strong> حتى <strong>{f2}</strong>",
    showDetail: "عرض التفاصيل",
    showAllAccounts: "عرض جميع الحسابات",
    agedAsOfThisDate: "العمر اعتبارًا من هذا التاريخ",
    grandTotal: "المجموع الكلي",
    receivableNo: "رقم المستحقات",
    showAllClients: "عرض جميع العملاء",
    copiedToClipboard: "تم النسخ إلى الحافظة!",
    sortOrder: "ترتيب الفرز",
    setAppliesTo: "الإعداد ينطبق على: {f}",
    date: "تاريخ",
    hotelName: "اسم الفندق",
    source: "المصدر",
    days130: "1-30 يوم",
    days3160: "31-60 يوم",
    days6190: "61-90 يوم",
    days91120: "91-120 يوم",
    days120: ">120 يوم",
    periodLabel: "{d1} إلى {d2}",
    downloadGSheet: "تحميل GSheet",
    downloadExcel: "تحميل إكسل",
    downloadPDF: "تحميل PDF",
    report: "تقرير",
    period: "فترة",
    group: "مجموعة",
    totalCost: "التكلفة الإجمالية",
    totalCostAdjust: "تعديل التكلفة الإجمالية",
    totalAdjustment: "الإجمالي المعدل",
    lineStatus: "حالة الخط",
    useSystematicApproval: "استخدم الموافقة النظامية",
    itemType: "نوع الصنف",
    article: "المادة",
    articleType: "نوع المادة",
    baseSellingPrice: "سعر البيع الأساسي",
    costPercentage: "نسبة التكلفة %",
    headerNoSeries: "سلسلة أرقام الرأس",
    lineNoSeries: "سلسلة أرقام السطر",
    lineDocumentNo: "رقم مستند السطر",
    outlet: "المنفذ",
    setDefaultDirectExpense: "تعيين مصروف مباشر افتراضي",
    notesOrReason: "ملاحظات / سبب",
    user: "مستخدم",
    approved: "موافق",
    rejected: "مرفوض",
    declined: "مرفوض",
    preparedBy: "أعد بواسطة",
    checkedBy: "تم التحقق بواسطة",
    approvedBy: "موافق عليه",
    approverName: "اسم الموافقة",
    sequence: "تسلسل",
    flowOrder: "ترتيب التدفق",
    priority: "أولوية",
    defaultPurchaseRequestPriority: "أولوية طلب الشراء الافتراضية",
    defaultDirectExpenseItemJournalBatch: "دفعة سجل عناصر المصروفات المباشرة الافتراضية",
    earliest: "الأبكر",
    latest: "الأحدث",
    showSummary: "عرض الملخص",
    delegatedTo: "مفوض إلى",
    footerText: "نص التذييل",
    formattingNotes: "يمكن تطبيق هذه العلامات التنسيقية على كل سطر: *غامق* _مائل_",
    showHotelLogo: "عرض شعار الفندق",
    showHotelAddress: "عرض عنوان الفندق",
    food: "طعام",
    beverage: "مشروب",
    material: "المادة",
    engineering: "الهندسة",
    showEngineering: "عرض حساب الهندسة في تبويب منفصل",
    coaID: "معرّف COA",
    addAccount: "إضافة حساب",
    selectAccountName: "اختر اسم الحساب",
    selectDimensionValue: "اختر قيمة الأبعاد",
    restore: "استعادة",
    setToNonDirectExpense: "تعيين كنفقات غير مباشرة",
    includeApprovalNotes: "تضمين ملاحظات الموافقة",
    reviewedBy: "مراجعة بواسطة",
    reviewedAt: "تم المراجعة في",
    delegatedAt: "مفوض في",
    delegatedFrom: "مفوض من",
    isOpen: "مفتوح",
    showAllItems: "عرض جميع العناصر",
    hideUnopenedItems: "إخفاء العناصر غير المفتوحة",
    summaryByLocation: "ملخص حسب الموقع",
    showAllBanks: "عرض جميع البنوك",
    splitVendorDescription: "وصف البائع المقسم",
    creditAccount: "حساب ائتماني",
    debitAccount: "حساب الخصم",
    totalCredit: "إجمالي الائتمان",
    totalDebit: "إجمالي الخصم",
    totalLedger: "إجمالي السجل",
    totalPayment: "إجمالي الدفع",
    summary: "ملخص",
    hideAmountInPurchaseRequestPrintout: "إخفاء المبلغ في طباعة طلب الشراء",
    showTotalCostInPurchaseRequestPrintVendorComparison: "عرض التكلفة الإجمالية في طلب الشراء مقارنة الموردين",
    enableDescriptionCopyToRemark: "تفعيل نسخ الوصف إلى الملاحظات في طلب الشراء",
    allowSOHZeroWhenStoreRequisitionIsSaved: "السماح برصيد صفر عند حفظ طلب المتجر",
    allowRequestedQtyBiggerThanSoh: "السماح بكمية أكبر من المخزون",
    useLastDirectCostWhenNoContract: "استخدم آخر تكلفة مباشرة عند عدم وجود سعر عقد",
    useLastDirectCostWhenNoContractNote: "عند تعيين المورد في طلب الشراء المعلق وعدم توفر سعر العقد، قم بكتابة بيانات المستخدم واستخدم آخر تكلفة مباشرة (ينطبق هذا أيضًا على طلب الشراء)",
    itemCodeGeneratedBySystem: "سيتم توليد رمز العنصر بواسطة النظام",
    mdrFee: "نسبة خصم التاجر {f} (%)",
    batchHasMdrFee: "الدفعة <strong>{f}</strong> تحتوي على خيارات معدل خصم التاجر:",
    showZeroBalance: "عرض رصيد صفر",
    targetEntry: "إدخال الهدف",
    approvalPrintout: "طباعة الموافقة",
    document: "وثيقة",
    outstanding: "متميز",
    documentsSelected: "المستندات المحددة",
    documentSelected: "تم اختيار المستند",
    defaultVendorSetup: "الإعداد الافتراضي للبائع",
    defaultClientSetup: "الإعداد الافتراضي للعميل",
    defaultItemSetup: "الإعداد الافتراضي للعنصر",
    noVat: "لا ضريبة قيمة مضافة",
    purchaseOrderDocumentFlow: "تدفق مستند طلب الشراء",
    dailyMarketListDocumentFlow: "تدفق مستند قائمة السوق اليومية",
    remark: "ملاحظة",
    deleteRemark: "حذف الملاحظة",
    taxIdentificationNumber: "رقم التعريف الضريبي",
    attachment: "مرفق",
    fileFormat: "صيغة الملف",
    adjustAllItems: "ضبط جميع العناصر",
    adjustFilteredItems: "تعديل العناصر المفلترة",
    adjustItem: "تعديل العنصر",
    showItemDetail: "عرض العنصر",
    showClientDetail: "عرض العميل",
    showPurchaseBook: "عرض كتاب الشراء",
    queryDate: "تاريخ الاستعلام",
    queryAdjustmentDate: "تاريخ الاستعلام والتعديل",
    adjustmentPostingDate: "تاريخ تعديل القيد",
    valueEntryID: "معرّف إدخال القيمة",
    costAmountAdjustment: "تعديل مبلغ التكلفة",
    viewData: "عرض البيانات",
    ileID: "معرّف ILE",
    lastValueEntryID: "معرّف آخر إدخال قيمة",
    unitCostThreshold: "حد تكلفة الوحدة",
    unitCostThresholdUsingLastDirectCost: "حد تكلفة الوحدة باستخدام آخر تكلفة مباشرة",
    minUnitCost: "أدنى تكلفة وحدة (%)",
    maxUnitCost: "أقصى تكلفة وحدة (%)",
    isReversed: "معكوس",
    reversedPostingDate: "تاريخ النشر المعكوس",
    descriptionForVendor: "الوصف (للبائع)",
    remarkInternalOnly: "ملاحظة الشراء (للاستخدام الداخلي فقط)",
    remarkInternalNoteForPurchasingOnly: "ملاحظة (ملاحظة داخلية للمشتريات فقط)",
    isDirectExpense: "مصروف مباشر",
    isDML: "هل هو DML",
    inputUOMID: "أدخل معرف وحدة القياس",
    inputUOMCode: "أدخل رمز وحدة القياس",
    inputUOMName: "أدخل اسم وحدة القياس",
    transferOrder: "طلب تحويل",
    negativeAdjustment: "تعديل سلبي",
    quantityEqualZero: "الكمية = 0",
    quantityGreaterThanZero: "الكمية > 0",
    costNegative: "تكلفة سلبية",
    groupByLocation: "تجميع حسب الموقع",
    groupByVendor: "تجميع حسب البائع",
    showAllARCard: "عرض جميع بطاقات الحسابات المستحقة",
    setToCompletelyReceived: "تم الاستلام بالكامل",
    unsetCompletelyReceived: "إلغاء التعيين بالكامل",
    defaultChartOfAccount: "الخطة المحاسبية الافتراضية",
    defaultCOAAmount: "مبلغ COA الافتراضي",
    defaultDescription: "الوصف الافتراضي",
    salesInvoiceNumberSeries: "رقم سلسلة فواتير المبيعات",
    invoiceHeaderAddress: "عنوان فاتورة الرأس",
    openingInventory: "فتح المخزون",
    incomingInventory: "المخزون الوارد",
    closingInventory: "المخزون الختامي",
    inventoryAvailable: "المخزون متوفر",
    grossConsumption: "الاستهلاك الإجمالي",
    creditsConsumption: "الرصيد - الاستهلاك",
    creditsComplimentaryCost: "رصيد - تكلفة مجانية",
    creditsInterDepartmentTransfer: "رصيد - تحويل بين الأقسام",
    otherAdjustment: "تعديل آخر",
    netConsumption: "الاستهلاك الصافي",
    netBeverageSales: "مبيعات المشروبات الصافية",
    netFoodSales: "صافي مبيعات الطعام",
    costOfSales: "تكلفة المبيعات",
    debitCost: "تكلفة السحب",
    generalSetup: "الإعدادات العامة",
    onlyShowSameQuantity: "عرض الكمية نفسها فقط",
    excludedHotel: "فندق مستبعد",
    idExcludedAutomatically: "الهوية أدناه {item} مستبعدة تلقائيًا",
    ileDocumentNo: "رقم مستند ILE",
    adjust: "تعديل",
    importFromExcel: "استيراد من إكسل",
    chooseFile: "اختر ملف",
    previewData: "معاينة البيانات",
    adjustingPleaseWait: "جاري التعديل، يرجى الانتظار...",
    showCoaDestination: "عرض وجهة الشهادة",
    defaultPrintShowCoaDestination: "طباعة افتراضية عرض وجهة COA",
    directExpense: "نفقات مباشرة",
    movementType: "نوع الحركة",
    excelFile: "ملف إكسل",
    businessRegistrationNumber: "رقم تسجيل الأعمال",
    appliedInMalaysia: "مطبق حاليًا في ماليزيا",
    inventoryAvailableFormula: "افتتاح + وارد + خصم",
    grossConsumptionFormula: "متاح - إغلاق",
    otherAdjustmentFormula: "الاستهلاك الإجمالي - التكلفة المجانية - بين الأقسام",
    journalDetail: "تفاصيل اليومية",
    sohDate: "تاريخ SOH",
    revaluationJournal: "دفتر إعادة التقييم",
    revaluateCost: "إعادة تقييم التكلفة",
    purchaseCost: "تكلفة الشراء",
    getPurchaseCost: "احصل على تكلفة الشراء",
    valueEntriesToAdjust: "إدخال القيم للتعديل",
    getValueEntriesToAdjust: "احصل على قيم الإدخالات للتعديل",
    processAdjustment: "تعديل العملية",
    updateUnitCost: "تحديث تكلفة الوحدة",
    unitCostPurchase: "تكلفة الوحدة للشراء",
    expectedTotalCost: "التكلفة الإجمالية المتوقعة",
    currentTotalCost: "التكلفة الإجمالية الحالية",
    currentUnitCost: "تكلفة الوحدة الحالية",
    purchaseUnitCost: "تكلفة الوحدة للشراء",
    diffUnitCost: "تكلفة الوحدة المختلفة",
    locationID: "معرّف الموقع",
    minimumCostDifference: "أقل فرق تكلفة",
    showInvoiceTaxBreakdown: "عرض تفاصيل ضريبة الفاتورة",
    documentStartDate: "تاريخ بدء الوثيقة",
    documentEndDate: "تاريخ انتهاء الوثيقة",
    beginning: "بداية",
    beginningQty: "الكمية الابتدائية",
    beginningValue: "القيمة الابتدائية",
    incomingQty: "الكمية الواردة",
    outgoingQty: "الكمية الخارجة",
    endingQty: "الكمية النهائية",
    endingValue: "القيمة النهائية",
    averagePrice: "السعر المتوسط",
    changeAppliedSalesInvoiceID: "تغيير معرف فاتورة المبيعات المطبقة",
    currentAppliedSalesInvoiceID: "معرّف فاتورة المبيعات الحالية",
    newAppliedSalesInvoiceID: "معرّف فاتورة المبيعات الجديدة",
    changeAppliedID: "تغيير معرف التطبيق",
    taxNo: "رقم الضريبة",
    taxID: "رقم الضريبة",
    showTaxForm: "عرض نموذج الضريبة",
    taxNoLabel: "رقم الضريبة",
    taxIDLabel: "رقم التعريف الضريبي",
    additionalTopMargin: "هامش علوي إضافي",
    additionalTopMarginHints: "مساحة هامش علوي إضافية لطباعة الفاتورة المستحقة",
    endingBalance: "الرصيد النهائي",
    ledgerMutation: "تغيير السجل",
    display: "عرض",
    receiptDate: "تاريخ الإيصال",
    aging: "تقدم في السن",
    detailByDay: "تفاصيل حسب اليوم",
    showPODetail: "عرض تفاصيل الطلب",
    logNo: "رقم السجل",
    itemJournalLogSeries: "سجل سلسلة اليومية للعناصر",
    printOptions: "خيارات الطباعة",
    allowChangeUnitCostGreaterThanOriginal: "السماح بتغيير تكلفة الوحدة أكبر من الأصل",
    allowChangeUnitCostLessThanOriginal: "السماح بتغيير تكلفة الوحدة أقل من الأصل",
    actual: "فعلي",
    deliveryNo: "رقم التوصيل",
    showVendorDeliveryNoOnPrintout: "عرض رقم تسليم البائع في الطباعة",
    amountWithCurrency: "المبلغ ({c})",
    balanceWithCurrency: "الرصيد ({c})",
    centerHotelLogo: "عرض شعار الفندق في وسط الورقة",
    isFreeOfCharge: "مجاني",
    businessRegistrationNumberNew: "رقم تسجيل الأعمال (جديد)",
    businessActivityDescription: "وصف النشاط التجاري",
    sstRegistrationNumber: "رقم تسجيل ضريبة الخدمة والمبيعات",
    msicCodeNumber: "رقم رمز MSIC",
    msicDescription: "وصف MSIC",
    totalBalance: "الرصيد الكلي",
    showPostingDateColumn: "عرض عمود تاريخ النشر",
    tin1Label: "رقم التعريف الضريبي 1",
    tin1Value: "قيمة TIN 1",
    tin2Label: "ملصق TIN 2",
    tin2Value: "قيمة TIN 2",
    welcomeText: "عزيزي/عزيزتي،  \nشكرًا لاختيارك {h} - يرجى العثور على الفاتورة المرفقة:",
    showWithdrawApproval: "عرض موافقة السحب",
    paidAmount: "المبلغ المدفوع",
    remaining: "متبقي",
    allowCreateNewSetPaymentJournal: "السماح بإنشاء مجموعة جديدة من دفاتر الدفع",
    allowCreateNewSetCashReceiptJournal: "السماح بإنشاء مجموعة جديدة من دفاتر إيصالات النقد",
    journalNotAllowForDirectPosting: "لا يُسمح بالنشر المباشر للمجلات لـ {f}",
    journalHasZeroValue: "المجلات لـ {f}، قيمتها صفر",
    journalNotBalanced: "المجلات لـ {f}، غير متوازنة",
    showPreviousMonthAdjustment: "عرض تعديلات الأشهر السابقة",
    noDimensionValue: "(بدون بعد)",
    isPreviousMonth: "الشهر السابق",
    showAdjustmentEntry: "عرض إدخال التعديل",
    adjustmentSource: "مصدر التعديل",
    distributeAmount: "توزيع المبلغ",
    distributeAmountEnablement: "أضف حساب بنك واحد على الأقل أولاً لتمكين هذا الخيار",
    distributeAmountMessage: "سيتم توزيع المبلغ الإجمالي تلقائيًا على الحساب المصرفي",
    allowChangeItemLastDirectCost: "السماح بتغيير آخر تكلفة مباشرة للعنصر",
    allowDirectReleasePO: "السماح بإصدار طلب الشراء مباشرة",
    useSystematicApprovalDML: "استخدم الموافقة النظامية (DML)",
    allowFreeOfChargeOnDirectExpense: "السماح بالمجان على المصاريف المباشرة",
    statistic: "إحصائيات",
    chequeNumber: "رقم الشيك",
    showSignatureOnApproval: "عرض التوقيع عند الموافقة",
    setVatProduct: "تعيين ضريبة القيمة المضافة للمنتج",
    locations: "المواقع",
    allLocations: "جميع المواقع",
    itemCodeOrItemName: "رمز العنصر أو اسم العنصر",
    account: "حساب",
    onBehalfOfLabel: "بالنيابة عن",
    sendEmail: "أرسل بريد إلكتروني",
    useHOAInvoice: "استخدم فاتورة HOA",
    telephone: "هاتف",
    mobilePhone: "الهاتف المحمول",
    purchaseOrderNO: "رقم طلب الشراء",
    requestNo: "رقم الطلب",
    costCenter: "مركز التكلفة",
    tax: "ضريبة",
    loc: "موقع",
    uom: "وحدة القياس",
    qty: "الكمية",
    dis: "إلغاء",
    supplierAddress: "عنوان المورد",
    voucherNo: "رقم القسيمة",
    refNo: "رقم المرجع",
    paymentDueDate: "تاريخ استحقاق الدفع",
    bankCode: "رمز البنك",
    showAsGroup: "عرض كـ {s} مجموعة",
    showAllVendor: "عرض جميع الموردين",
    affectedData: "البيانات المتأثرة",
    newPostingDate: "تاريخ النشر الجديد",
    hide: "إخفاء",
    endingNumber: "رقم النهاية",
    downloadPrintoutPDF: "تحميل PDF للطباعة",
    taxNumberSeries: "سلسلة رقم الضريبة",
    taxCompany: "شركة الضرائب",
    taxExpiryDate: "تاريخ انتهاء الضريبة",
    taxPhone: "هاتف الضرائب",
    taxEmail: "البريد الإلكتروني للضرائب",
    taxReceiptNo: "رقم الإيصال الضريبي",
    unitNo: "رقم الوحدة",
    unitOwnerName: "اسم مالك الوحدة",
    company: "شركة",
    selectedItems: "العناصر المحددة",
    hoaCompanyName: "اسم شركة HOA",
    hoaRoomType: "نوع غرفة HOA",
    hoaUnitNo: "رقم وحدة HOA",
    emailTemplate: "قالب البريد الإلكتروني",
    salesInvoiceSendEmailTemplate: "قالب إرسال بريد الفاتورة التجارية",
    templateVariables: "متغيرات القالب",
    exampleTemplate: "نموذج مثال",
    invoiceLabelSetup: "إعداد تسمية الفاتورة",
    updatePurchaseOrderStatus: "تحديث حالة طلب الشراء",
    updatePurchaseOrderStatusDescription: "اختر حالة جديدة لطلب الشراء من القائمة المنسدلة أدناه.",
    currentStatus: "الحالة الحالية",
    newStatus: "حالة جديدة",
    preview: "معاينة",
    sortBy: "ترتيب حسب",
    allowEditPurchaseRequestInApproval: "السماح بتعديل طلب الشراء في الموافقة",
    allowEditPurchaseRequestInApprovalNote: "يمكن فقط للمستخدمين غير الموجودين في قائمة الموافقة التعديل. يعمل هذا مع إذن 'السماح للمستخدم بتعديل طلب الشراء في الموافقة'.",
    processToPoCopyDescription: "نسخ وصف الطلب",
    show0Quantity: "عرض 0 كمية",
    selectedLocations: "المواقع المحددة",
    selectedInventoryPostingGroups: "مجموعات نشر المخزون المحددة",
    noItemsSelected: "لا توجد عناصر محددة",
    noLocationsSelected: "لا توجد مواقع محددة",
    noInventoryPostingGroupsSelected: "لا توجد مجموعات نشر المخزون محددة",
    vendorSource: "مصدر البائع",
    downloadCSV: "تحميل CSV",
    delegatedBy: "مفوّض من",
    showCustomerAccountType: "عرض نوع حساب العميل",
    printGeneralLedgerInformationonPostedDocument: "طباعة معلومات دفتر الأستاذ العام على المستند المنشور",
    submittedAt: "تاريخ الإرسال",
    submittedBy: "مقدم من",
    withdrawalAt: "السحب عند",
    withdrawalBy: "سحب بواسطة",
    expectedDueDate: "تاريخ الاستحقاق",
    documentApprovalType: "نوع موافقة الوثيقة",
    useExtendedPRDescriptionLength: "استخدم طول وصف PR الممتد (255 حرفًا)",
    allowMultilineDescription: "السماح بوصف متعدد الأسطر على طلب الشراء/طلب الشراء",
    showUpdateLowestCostVendorComparisonPurchaseRequest: "إظهار مقارنة أقل تكلفة للبائع في طلب الشراء",
    printPreview: "معاينة الطباعة",
    descriptionMultiLineHint: "اضغط على Enter أو اكتب ; لإضافة سطر جديد",
    appliesToPostedPurchaseCreditMemoId: "رقم مذكرة ائتمان الشراء المطبقة",
    createPaymentJournal: "إنشاء سجل المدفوعات",
    createCashReceiptJournal: "إنشاء سجل إيصالات نقدية",
    lockPostingDateTheSameAsWorkingDateInFO: "تثبيت تاريخ النشر كالتاريخ العامل في FO",
    lockPostingDateTheSameAsWorkingDateInFONote: "لإيصال النقد وحساب التسوية",
    totaling: "إجمالي",
    defaultDimensionValue: "قيمة البعد الافتراضية",
    dimensionSetID: "معرّف مجموعة الأبعاد",
    dimensionName: "اسم البعد",
    dimensionCode: "رمز الأبعاد",
    optionCode: "رمز الخيار",
    defaultValueCode: "رمز القيمة الافتراضية",
    allowed: "مسموح",
    allowedValueCode: "رمز القيمة المسموح بها",
    dimensionValueName: "اسم قيمة البعد",
    dimensionValueCode: "رمز قيمة الأبعاد",
    selectAllowedDimensionValues: "اختر قيم الأبعاد المسموح بها لهذه البُعد",
    selectDimensionToViewAllowedValues: "اختر بُعدًا لعرض القيم المسموح بها",
    selectedValues: "القيم المحددة",
    showPositive: "عرض الإيجابي",
    showBankAccountOnPaymentListReport: "عرض حساب البنك في جميع تقارير قائمة المدفوعات",
    footerFontType: "نوع خط التذييل",
    standardFontHint: "خط قياسي من النظام",
    monospaceFontHint: "كل حرف، بما في ذلك الحروف والأرقام والمسافات، يشغل نفس العرض الأفقي",
    signatureAlignment: "محاذاة التوقيع",
    allowEditReleasedPOLineZeroQtyReceived: "السماح بتحرير أوامر الشراء المفتوحة والمصدرة عند استلام الكمية صفر",
    overridePrLineFromPo: "تجاوز خط PR عند تعديل خط PO",
    month1: "شهر واحد",
    month2: "شهرين",
    month3: "3 أشهر",
    month4: "4 أشهر",
    moreThan4Months: "> 4 أشهر",
    printingDateTime: "تاريخ ووقت الطباعة",
    disc: "قرص",
    allowDeletePrSourcedPoLine: "السماح بحذف خطوط أوامر الشراء المستندة إلى طلب الشراء (يعيد خط الطلب إلى حالة مفتوح)",
    purchaseRequestExpiredRange: "مدة انتهاء طلب الشراء (أيام)",
    purchaseOrderExpiredRange: "مدة انتهاء طلب الشراء (أيام)",
    enablePrintButtonForOnlyReleasedDocuments: "تفعيل زر الطباعة فقط إذا كانت حالة الوثيقة مُعتمدة",
    currentDimensionSetID: "معرّف مجموعة الأبعاد الحالية",
    newDimensionSetID: "معرّف مجموعة الأبعاد الجديدة",
    lastMovement: "آخر حركة",
    age: "العمر",
    soh: "SOH",
    changeGLAccount: "تغيير حساب GL",
    postPurchaseInvoice: "فاتورة ما بعد الشراء",
    draft: "مسودة",
    setZeroQuantityPhysicalAsBlank: "اجعل الكمية 0 (الجرد الفعلي) فارغة",
    reviewYtdReportComparisonYear: "مقارنة تقرير YTD للسنة",
    reviewPnlYtdSummaryComparisonYear: "ملخص مقارنة الربح والخسارة حتى الآن",
    reviewPnlYtdConsolidationComparisonYear: "مقارنة تجميع الأرباح والخسائر حتى الآن",
    reviewBalanceSheetYtdSummaryComparisonYear: "ملخص الميزانية العمومية حتى تاريخه مقارنة بالسنة",
    budget: "ميزانية",
    taxRegisterNumber: "رقم تسجيل الضريبة",
    purchaseReceiptNo: "رقم الطلب",
    purchaseReceiptPostingDate: "تاريخ نشر PR",
    amountDue: "المبلغ المستحق",
    periodDate: "تاريخ الدورة",
    parafInitial: "توقيع / أولي",
    appliesToPostedPurchaseInvoiceNo: "رقم فاتورة الشراء المطبقة",
    showContactNameOnPrintSummary: "عرض اسم جهة الاتصال في ملخص الطباعة",
    depositAccountCode: "رمز حساب الإيداع",
    depositAccountName: "اسم حساب الإيداع",
    boDepositAccountCode: "رمز حساب إيداع BO",
    boDepositAccountName: "اسم حساب إيداع BO",
    foDepositAccountNo: "رقم حساب إيداع FO",
    foDepositAccountName: "اسم حساب إيداع FO",
    depositAccountPostingGroupCode: "رمز مجموعة تسجيل حساب الإيداع",
    depositAccountPostingGroupName: "اسم مجموعة تسجيل حساب الإيداع",
    appliedDepositAccountLedgerEntryId: "معرّف مُطبّق",
    showInDocument: "عرض في المستند",
    showInDocumentHint: "المستويات المحددة تظهر في الوثيقة تضيف أعمدة الرمز والاسم إلى: طلب الشراء، أمر الشراء، إيصال الشراء، فاتورة الشراء، مذكرة ائتمان الشراء، طلب المخزن، فاتورة المبيعات، مذكرة ائتمان المبيعات، اليومية العامة، اليومية العامة للميزانية، اليومية الخاصة بالعناصر، اليومية للجرد الفعلي",
    automaticFillInvoiceNo: "املأ رقم الفاتورة تلقائيًا برقم تسليم المورد",
    useGeneralBudgetEntryForPnlBudget: "استخدم إدخال الميزانية العامة لميزانية الأرباح والخسائر",
    recalledAt: "تم استدعاؤه في",
    recalledBy: "تم استدعاؤه بواسطة",
    hideUnitCostColumn: "إخفاء عمود تكلفة الوحدة",
    hideTotalAmountColumn: "إخفاء عمود المبلغ الكلي",
    showPrintedDateTime: "عرض تاريخ ووقت الطباعة",
    printedAt: "تم الطباعة في",
    bankAccountName: "اسم حساب البنك",
    includedInGop: "مدرج في GOP",
    chargeDate: "تاريخ الشحن",
    banquet: "وليمة",
    secondaryAccountNo: "رقم الحساب الثانوي",
    currentStockOnHand: "المخزون الحالي",
    baseCurrentStockOnHand: "حالة التشغيل الأساسية الحالية",
    showCurrentSohInPurchaseRequest: "عرض المخزون الحالي في طلب الشراء",
    showCurrentSohInPurchaseOrder: "عرض رصيد المخزون الحالي في طلب الشراء",
    allowPositiveAdjustmentPhysicalInventory: "السماح بالتعديل الإيجابي على سجل الجرد الفعلي",
    dimensionValueID: "معرّف قيمة البُعد",
    purchaseRequestMaxBackdatedDays: "أقصى عدد من الأيام المؤرخة",
    purchaseOrderMaxBackdatedDays: "أقصى عدد من الأيام المتأخرة",
    purchaseInvoiceMaxBackdatedDays: "أقصى عدد من الأيام المؤرخة",
    storeRequisitionMaxBackdatedDays: "أقصى عدد من الأيام المتأخرة",
    newQuantity: "الكمية الجديدة",
    editQuantity: "تعديل الكمية",
    requestedQuantity: "الكمية المطلوبة",
    allowApproverEditQuantityLessThanOriginal: "السماح للموافق بتعديل الكمية أقل من الأصل",
    wht: "ضريبة المبيعات",
    hideWhtWhenZero: "إخفاء الضريبة عند كون المبلغ صفر",
    useImportWithReservation: "استخدم الاستيراد مع الحجز",
    includeReservationDetail: "تضمين تفاصيل الحجز",
    contractValidFrom: "سريان العقد من",
    contractValidTo: "سريان العقد حتى",
    paymentStatus: "حالة الدفع",
    useCompanyHeaderAndLogoOnPrintout: "استخدم رأس الشركة والشعار في رأس الطباعة",
    supplierAndHotelVatLabel: "علامة ضريبة القيمة المضافة للمورد والفندق",
    supplierInfo: "معلومات المورد",
    shipToBillTo: "شحن إلى / فاتورة إلى",
    reconciliationWhtGlAccount: "حساب ضريبة الاستقطاع",
    whtAccountMustDiffer: "يجب أن يختلف حساب ضريبة الاستقطاع عن حساب دفتر الأستاذ الافتراضي",
    whtFee: "ضريبة الاستقطاع (%)",
    batchHasWhtFee: "يتم تطبيق ضريبة الاستقطاع <strong>{f} %</strong> على هذه الدفعة.",
    batchHasWhtOptions: "نسبة ضريبة الاستقطاع:",
    freePercentage: "نسبة مجانية",
    feeRoundingDigits: "أرقام تقريب الرسوم (0-3)",
    feeRoundingDigitsRange: "يجب أن تكون أرقام تقريب الرسوم عددًا صحيحًا من 0 إلى 3",
    reconciliationFeeRoundingDigits: "أرقام تقريب رسوم التسوية (0-3)",
    reconciliationFeeRoundingDigitsHint: "الأرقام العشرية المحتفظ بها على خصم التاجر ومبالغ ضريبة الاستقطاع في قيود تسوية الحسابات",
    creditAccountName: "اسم حساب الائتمان",
    debitAccountName: "اسم حساب الخصم",
    defaultCreditAccountName: "اسم حساب الائتمان الافتراضي",
    defaultDebitAccountName: "اسم حساب الخصم الافتراضي",
    defaultCreditAccount: "حساب الائتمان الافتراضي",
    defaultDebitAccount: "حساب الخصم الافتراضي",
  },
  validation: {
    baseRequired: "الحقل مطلوب",
    required: "{f} مطلوب",
    longerThan: "{f} يجب ألا يكون أطول من {v} حرفًا",
    generalProductPostingGroupRequired: "مجموعة ترحيل المنتجات العامة مطلوبة، يرجى الاختيار من القائمة المنسدلة",
    inventoryPostingGroupRequired: "مجموعة ترحيل المخزون مطلوبة، يرجى الاختيار من القائمة المنسدلة",
    baseUnitOfMeasurementRequired: "وحدة القياس الأساسية مطلوبة، يرجى الاختيار من القائمة المنسدلة",
    defaultUnitOfMeasurementRequired: "وحدة القياس الافتراضية مطلوبة، يرجى الاختيار من القائمة المنسدلة",
    lineMoreThan: "{f} السطر يجب ألا يتجاوز {v} أسطر",
    exceed: "{f} يجب ألا يتجاوز {v}",
    dateNotAfter: "تاريخ '{f1}' لا يجب أن يكون بعد '{f2}'",
    dateNotBefore: "لا يجب أن تكون تاريخ '{f1}' قبل '{f2}'",
    dateNotBefore2: "{f1} التاريخ يجب ألا يكون قبل تاريخ {f2} ({f3})",
    dateNotBefore3: "{f1} التاريخ لا يجب أن يكون قبل {f2} التاريخ",
    unitCostExceedOrBelowLastPrice: "لا يمكن أن تكون تكلفة الوحدة أعلى من {v1} أو أقل من {v2} من السعر الأخير",
    greaterThan: "القيمة يجب أن تكون أكبر من {v}",
    max20Lines: "يجب ألا يتجاوز النص 20 سطرًا",
    maxLines: "يجب ألا يتجاوز النص {f} سطرًا",
    completeRequiredFields: "يرجى إكمال جميع الحقول المطلوبة قبل النشر. تحقق من الحقول المميزة في الجدول.",
    cannotPostWhenUseSystematicApproval: "لا يمكن نشر فاتورة الشراء عند استخدام الموافقة النظامية",
    dimensionAlreadyInList: "هذه البُعد لديها قيمة بالفعل في القائمة. عدل الصف بدلاً من إضافة صف جديد.",
    incompleteDimensionRow: "يجب أن تحتوي كل صف على بُعد وقيمة. أكمل أو احذف الصف غير المكتمل.",
    dimensionsNotLoaded: "تعذر تحميل الأبعاد الحالية. أغلق وأعد فتح هذه النافذة قبل الحفظ.",
    linesTotalCannotBeNegative: "لا يمكن أن يكون مجموع جميع السطور سالبًا",
    fourDigitYear: "أدخل سنة مكونة من 4 أرقام",
    physicalQuantityNegative: "الكمية الفيزيائية لا يمكن أن تكون سلبية. أدخل الكمية الم counted (0 إذا لم توجد).",
    maxBackdatedDaysRange: "أدخل عدد كامل من الأيام بين 0 و 30",
    quantityGreaterThanRequested: "الكمية لا يمكن أن تكون أكبر من الكمية المطلوبة ({v})",
    contractValidToBeforeFrom: "تاريخ انتهاء العقد لا يمكن أن يكون قبل تاريخ بدء العقد",
    idtDeleteOnlyOpen: "يمكن حذف التحويل المفتوح أو المرفوض الذي لم يتم نشره فقط",
  },
  textFormat: {
    addFromReceipt: "إضافة من الاستلام : {f} ",
  },
  l: {
    add: "إضافة",
    addCashDesk: "إضافة صندوق نقدي",
    addChannel: "إضافة قناة",
    addCity: "إضافة مدينة",
    addChannelClientCompositionMapping: "إضافة تعيين تكوين عميل القناة",
    addChannelHotelRateCodeMapping: "إضافة تعيين رمز سعر الفندق للقناة",
    addChannelHotelRoomTypeMapping: "إضافة تعيين نوع غرفة الفندق للقناة",
    addCountry: "إضافة دولة",
    addCreditCardType: "إضافة نوع بطاقة ائتمان",
    addGeneralJournal: "إضافة دفتر يومية عام",
    addJournalAccountType: "إضافة نوع حساب دفتر اليومية",
    addJournalBatch: "إضافة دفعة دفتر اليومية",
    addJournalTemplate: "إضافة قالب دفتر اليومية",
    addRoomStatus: "إضافة حالة الغرفة",
    addRoomType: "إضافة نوع الغرفة",
    adminCode: "رمز المسؤول",
    adminName: "اسم المسؤول",
    adminNameAscii: "اسم المسؤول ASCII",
    adminType: "نوع المسؤول",
    backOffice: "الخلفية الإدارية",
    bankAccount: "الحساب البنكي",
    bankAccountId: "معرف الحساب البنكي",
    beverage: "مشروب",
    beverageToday: "مشروب اليوم",
    bookingSource: "مصدر الحجز",
    breakdownListAt: "قائمة التفاصيل في",
    breakdownListOf: "قائمة التفاصيل لـ",
    cancel: "إلغاء",
    cancelProcess: "إلغاء العملية",
    capital: "رأس المال",
    cashDesk: "صندوق نقدي",
    changeClientPostingGroup: "تغيير مجموعة ترحيل العميل",
    channel: "قناة",
    channelAgencyCode: "رمز وكالة القناة",
    channelClientCompositionMapping: "تعيين تكوين عميل القناة",
    channelHotelRateCodeMapping: "تعيين رمز سعر الفندق للقناة",
    channelHotelRoomTypeMapping: "تعيين نوع غرفة الفندق للقناة",
    channelId: "معرف القناة",
    channelManager: "مدير القناة",
    channelRateCode: "رمز سعر القناة",
    channelRoomType: "نوع غرفة القناة",
    channelRoomTypeCode: "رمز نوع غرفة القناة",
    city: "مدينة",
    cityAlt: "مدينة بديلة",
    cityAscii: "مدينة ASCII",
    code: "رمز",
    country: "دولة",
    countryId: "معرف الدولة",
    credit: "ائتمان",
    creditCard: "بطاقة ائتمان",
    creditCardType: "نوع بطاقة الائتمان",
    client: "عميل",
    clientNo: "رقم العميل",
    clientLedger: "دفتر العميل",
    currencyID: "معرف العملة",
    currencyName: "اسم العملة",
    dailyFlashCostReport: "تقرير التكلفة اليومية",
    dashboard: "لوحة التحكم",
    defaultBookingSource: "مصدر الحجز الافتراضي",
    defaultMarketSegment: "القطاع السوقي الافتراضي",
    delete: "حذف",
    deleteConfirmation: "تأكيد الحذف",
    density: "الكثافة",
    description: "الوصف",
    documentNo: "رقم المستند",
    documentType: "نوع المستند",
    documentFlowNotFound: "لم يتم العثور على تدفق المستند بالرمز {f}",
    downloadExcel: "تنزيل Excel",
    downloadGSheet: "تنزيل GSheet",
    downloadPDF: "تنزيل PDF",
    downloadReport: "تنزيل التقرير",
    downloadReportToGSheet: "تنزيل التقرير إلى GSheet",
    downloadReportToGSheetMacro: "تنزيل التقرير إلى GSheet (ماكرو)",
    downloadReportToExcel: "تنزيل التقرير إلى Excel",
    downloadReportToExcelMacro: "تنزيل التقرير إلى Excel (ماكرو)",
    edit: "تعديل",
    editCashDesk: "تعديل صندوق نقدي",
    editChannel: "تعديل قناة",
    editCity: "تعديل مدينة",
    editChannelClientCompositionMapping: "تعديل تعيين تكوين عميل القناة",
    editChannelHotelRateCodeMapping: "تعديل تعيين رمز سعر الفندق للقناة",
    editChannelHotelRoomTypeMapping: "تعديل تعيين نوع غرفة الفندق للقناة",
    editCountry: "تعديل دولة",
    editCreditCardType: "تعديل نوع بطاقة الائتمان",
    editGeneralJournal: "تعديل دفتر اليومية العام",
    editJournalAccountType: "تعديل نوع حساب دفتر اليومية",
    editJournalBatch: "تعديل دفعة دفتر اليومية",
    editJournalTemplate: "تعديل قالب دفتر اليومية",
    editRoomStatus: "تعديل حالة الغرفة",
    editRoomType: "تعديل نوع الغرفة",
    editCost: "تعديل التكلفة",
    editRemainingQuantity: "تعديل الكمية المتبقية",
    editRemainingAmount: "تعديل المبلغ المتبقي",
    editRemainingAmountWarning: "تحذير: هذا يستبدل مباشرة المبلغ المتبقي وحالة الفتح لقيد دفتر أستاذ مُرحّل. تأكد من مراجعة القيود ذات الصلة بعد ذلك.",
    editStoreRequisitionPosted: "تعديل طلب المتجر المنشور",
    entryNo: "رقم القيد",
    failed: "فشل",
    failedToPrint: "فشل الطباعة",
    food: "طعام",
    foodToday: "طعام اليوم",
    frontOffice: "الاستقبال",
    generalJournal: "دفتر اليومية العام",
    genProdPostGroupID: "معرف مجموعة ترحيل المنتجات",
    glAccountID: "معرف الحساب العام",
    glAccountName: "اسم الحساب العام",
    glAccountNo: "رقم الحساب العام",
    guestNumber: "رقم الضيف",
    headerDescription: "وصف العنوان",
    headerClientName: "اسم العميل في العنوان",
    headerClientAddress: "عنوان العميل في العنوان",
    hotelAgency: "وكالة الفندق",
    hotelAgencyGroup: "مجموعة وكالات الفنادق",
    hotelClient: "عميل الفندق",
    hotelRate: "سعر الفندق",
    hotelRoomType: "نوع غرفة الفندق",
    importUnitCost: "استيراد تكلفة الوحدة",
    importQuantity: "استيراد الكمية",
    iso2Code: "رمز ISO2",
    journalAccountNo: "رقم حساب دفتر اليومية",
    journalAccountType: "نوع حساب دفتر اليومية",
    journalBatch: "دفعة دفتر اليومية",
    journalTemplate: "قالب دفتر اليومية",
    latitude: "خط العرض",
    lineDescription: "وصف السطر",
    lineLocationID: "معرف موقع السطر",
    lineLocationName: "اسم موقع السطر",
    lineNo: "رقم السطر",
    lineUnitOfMeasurementID: "معرف وحدة القياس للسطر",
    lineUnitOfMeasurementName: "اسم وحدة القياس للسطر",
    longitude: "خط الطول",
    macro: {
      cost: "تكلفة كلية",
      revenue: "إيراد كلي",
    },
    mandatory: "إلزامي",
    marketSegment: "القطاع السوقي",
    masterData: "البيانات الرئيسية",
    month: {
      _: "شهر",
      list: {
        full: "['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']",
        abbr: "['ينا', 'فبر', 'مار', 'أبر', 'ماي', 'يون', 'يول', 'أغس', 'سبت', 'أكت', 'نوف', 'ديس']",
      },
    },
    name: "الاسم",
    new: "جديد",
    no: "لا",
    numericCode: "رمز رقمي",
    ofCreditComplimentary: "من الائتمان - مجاملة",
    ofCreditCover: "من الائتمان - تغطية",
    ofCreditOfficeCheck: "من الائتمان - شيك مكتبي",
    ofCreditEntertainment: "من الائتمان - ترفيه",
    ofPurchaseReceipt: "من إيصال الشراء",
    ofStoreRequest: "من طلب المتجر",
    officialStateName: "الاسم الرسمي للدولة",
    originalAmount: "المبلغ الأصلي",
    paymentTermID: "معرف شرط الدفع",
    paymentTermCode: "رمز شرط الدفع",
    population: "عدد السكان",
    populationProper: "عدد السكان الفعلي",
    postingDate: "تاريخ الترحيل",
    rate: "السعر",
    ranking: "الترتيب",
    revenueCenterCode: "رمز مركز الإيرادات",
    roomStatus: "حالة الغرفة",
    roomType: "نوع الغرفة",
    sameName: "نفس الاسم",
    save: "حفظ",
    simpleMapsCityId: "معرف SimpleMapsCity",
    successful: "ناجح",
    timezone: "المنطقة الزمنية",
    vatProdPostGroupCode: "رمز مجموعة ترحيل ضريبة القيمة المضافة للمنتجات",
    vatProdPostGroupID: "معرف مجموعة ترحيل ضريبة القيمة المضافة للمنتجات",
    whtVatProdPostGroupCode: "رمز مجموعة ضريبة القيمة المضافة المقتطعة",
    whtVatProdPostGroupID: "معرف مجموعة ضريبة القيمة المضافة المقتطعة",
    yes: "نعم",
    googleSheets: "Google Sheets",
    debit: "مدين",
    previousBalance: "الرصيد السابق",
    billDate: "تاريخ الفاتورة",
    aged: "عمر",
    poNoCoa: "رقم الطلب / شهادة المطابقة",
    receiptNoDesc: "رقم الإيصال / الوصف",
    and: "و",
    cents: "فلس",
    processExpired: "انتهت صلاحية العملية",
    revertExpired: "استرجاع منتهي الصلاحية",
    notes: "ملاحظات",
  },
  m: {
    confirmDelete: "هل أنت متأكد أنك تريد حذف {f}؟ لا يمكن التراجع عن هذه العملية.",
    err: {
      betLen: "{f} يجب أن يكون بين {v1} و {v2} حرفًا",
      ge: "{f} يجب أن يكون أكبر من أو يساوي {v}",
      gt: "{f} يجب أن يكون أكبر من {v}",
      le: "{f} يجب أن يكون أقل من أو يساوي {v}",
      lt: "{f} يجب أن يكون أقل من {v}",
      maxLen: "{f} يجب أن يكون بحد أقصى {v} حرفًا",
      maxVal: "القيمة القصوى لـ {f} هي {v}{x}",
      minLen: "{f} يجب أن يكون بحد أدنى {v} حرفًا",
      minMaxVal: "قيمة {f} يجب أن تكون من {v1}{x} إلى {v2}{x}",
      minVal: "القيمة الدنيا لـ {f} هي {v}{x}",
      number: "{f} يجب أن يكون رقمًا، موجبًا أو سالبًا",
      numeric: "{f} يجب أن يتكون فقط من أرقام",
      req: "{f} مطلوب",
    },
    entryEditorWarning: "تأكد من بقاء الفترة المحاسبية مفتوحة وأن حساب المستخدم الخاص بك لديه الأذونات اللازمة لإعداد ترحيل المستخدم. سيتم تسجيل أي تعديلات تم إجراؤها على هذا النموذج بأمان.",
    entryDeleteWarningUpdate: "تأكد من أن جميع البيانات أدناه سيتم إعادة فتحها بسبب إجراء الحذف. سيتم تسجيل أي تعديلات تم إجراؤها من هذا الإجراء بأمان",
    entryDeleteBaleWarningDelete: "تحذير: سيؤدي المتابعة في هذا الإجراء إلى الإزالة الدائمة لجميع قيود دفتر الحسابات البنكية المرتبطة برقم المستند المحدد. يرجى التأكد من صحة رقم المستند، حيث أن هذه العملية لا رجعة فيها. سيتم تسجيل أي تعديلات تم إجراؤها من هذا الإجراء بأمان",
    errorEmptyDocumentNumber: "يرجى اختيار رقم المستند أولاً.",
    successDeleteBale: "تم حذف قيود دفتر الحسابات البنكية",
    successDeletePostedInvoice: "تم حذف الفاتورة المرحلة",
    successMovePurchaseInvoiceLines: "تم نقل بنود فاتورة الشراء بنجاح",
    movePurchaseInvoiceLinesWarning: "ستقوم هذه العملية بنقل جميع البنود من فاتورة الشراء المصدر المحددة إلى فاتورة الشراء الهدف. يرجى التأكد من اختيار الفواتير الصحيحة حيث أن هذه العملية لا يمكن التراجع عنها.",
    pleaseSelectTargetPurchaseInvoice: "يرجى اختيار فاتورة الشراء الهدف",
    sourceTargetPurchaseInvoiceCannotBeSame: "لا يمكن أن تكون فاتورة الشراء المصدر والهدف متشابهتين",
    setVendorChangePriceReminder: "سيتم تحديد التكلفة بناءً على سعر عقد المورد كلما كان هذا السعر متاحًا",
    successChangeStatusPurchaseRequisition: "تم تحديث حالة طلب الشراء",
    successImportGlb: "تم استيراد ميزانية دفتر الأستاذ العام بنجاح!",
    successSaveGlb: "تم حفظ ميزانية دفتر الأستاذ العام بنجاح!",
    entryDeleteCleWarningDelete: "تحذير: سيؤدي المتابعة في هذا الإجراء إلى الإزالة الدائمة لجميع قيود دفتر العميل المرتبطة برقم المستند المحدد. يرجى التأكد من صحة رقم المستند، حيث أن هذه العملية لا رجعة فيها. سيتم تسجيل أي تعديلات تم إجراؤها من هذا الإجراء بأمان",
    entryDeleteVleWarningDelete: "تحذير: سيؤدي المتابعة في هذا الإجراء إلى الإزالة الدائمة لجميع قيود دفتر المورد المرتبطة برقم المستند المحدد. يرجى التأكد من صحة رقم المستند، حيث أن هذه العملية لا رجعة فيها. سيتم تسجيل أي تعديلات تم إجراؤها من هذا الإجراء بأمان",
    successDeleteCle: "تم حذف قيود دفتر العميل",
    successDeleteVle: "تم حذف قيود دفتر المورد",
    successUpdateWitholdingTax: "تم تحديث ضريبة الاستقطاع",
    successChangeClientSales: "تم تحديث العميل",
    confirmLogout: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    confirmFlushSiteData: "هل أنت متأكد أنك تريد مسح بيانات الموقع؟ سيتم تسجيل خروجك وتحديث الصفحة.",
    successFlushSiteData: "تم مسح بيانات الموقع. سيتم تسجيل خروجك وسيتم تحديث الصفحة الآن.",
    successChangeBankAccount: "تم تغيير الحساب البنكي",
    currBankAccount: "الحساب البنكي الحالي",
    successChangeVendor: "تم تغيير البائع",
    currVendor: "البائع الحالي",
    successChangeDeliveryNo: "تم تغيير رقم التسليم",
    currDeliveryNo: "رقم التسليم الحالي",
    newDeliveryNo: "رقم التسليم الجديد",
    pleaseSelectPurchaseInvoiceFromTheList: "يرجى اختيار فاتورة شراء من القائمة أولاً",
    entryDeleteVeWarningDelete: "تحذير: ستؤدي هذه العملية إلى الحذف الدائم لجميع القيم المرتبطة برقم الوثيقة المحدد. يرجى التأكد من صحة رقم الوثيقة، حيث أن هذه العملية لا يمكن التراجع عنها. سيتم تسجيل أي تعديل تم من هذه العملية بشكل آمن.",
    successDeleteVe: "تم حذف إدخالات القيمة",
    entryDeleteGjeWarningDelete: "تحذير: ستؤدي هذه العملية إلى الحذف الدائم لجميع سجلات اليومية العامة المرتبطة برقم الوثيقة المحدد. يرجى التأكد من دقة رقم الوثيقة، حيث أن هذه العملية غير قابلة للتراجع. سيتم تسجيل أي تعديل يتم من هذه العملية بشكل آمن.",
    deleteGeneralJournalLogWarning: "لن يتم حذف قيود دفتر الأستاذ العام، فقط هذا السجل.",
    revertPostedInvoiceWarning: "ستؤدي هذه العملية إلى إزالة جميع قيود السجل المرتبطة وتعيين فاتورة الشراء كمسودة أو غير منشورة.",
    deletePostedInvoiceWarning: "ستؤدي هذه العملية إلى حذف جميع قيود السجل والفواتير المرتبطة.",
    changeCOAAndDescriptionWarning: "ستقوم هذه العملية بالتحديث فقط من خط فاتورة الشراء. يرجى التأكد من إجراء التحديثات في قيود دفتر الأستاذ العام بشكل منفصل.",
    successCreatePaymentJournal: "تم إنشاء سجل الدفع",
    successCreateCashReceiptJournal: "تم إنشاء سجل إيصالات النقدية",
    failedZeroRemainingAmount: "لا يمكن المتابعة. بعض البيانات تحتوي على رصيد صفر",
    failedAppliedEntries: "لا يمكن المتابعة. تم تطبيق بعض البيانات على الدفع",
    remainingAmountNotEqualOriginalAmount: "المبلغ المتبقي لا يساوي المبلغ الأصلي",
    deletePostedPurchaseCreditMemoWarning: "ستؤدي هذه العملية إلى حذف جميع قيود الدفتر المستندة ومذكرة ائتمان الشراء.",
    successDeletePostedMemo: "تم حذف المذكرة المنشورة",
    revertPostedPurchaseCreditMemoWarning: "ستؤدي هذه العملية إلى إزالة جميع قيود السجل المرتبطة وتعيين مستند مذكرة ائتمان الشراء كمسودة أو غير منشورة.",
    ytdComparisonYearHint: "عدد السنوات التاريخية الإضافية المعروضة في التقرير (0-3، 0 = إيقاف)",
    entryDeleteDaleWarningDelete: "تحذير: ستؤدي متابعة هذا الإجراء إلى الإزالة الدائمة لجميع قيود حساب الإيداع المرتبطة برقم الوثيقة المحدد. يرجى التأكد من دقة رقم الوثيقة، حيث أن هذه العملية لا يمكن عكسها. سيتم تسجيل أي تعديل تم من خلال هذا الإجراء بشكل آمن.",
    successDeleteDale: "تم حذف قيود دفتر حساب الإيداع",
    successChangeClient: "تم تغيير العميل",
    currClient: "العميل الحالي",
    successChangeDepositAccount: "تم تغيير حساب الإيداع",
    currDepositAccount: "حساب الإيداع الحالي",
    noDimensionsConfigured: "لا توجد أبعاد مكونة لهذا التقرير بعد.",
    noDimensionsAvailable: "تمت إضافة جميع أبعاد هذا الفندق بالفعل.",
    dimensionCountNone: "لا توجد أبعاد",
    dimensionCountOne: "بُعد واحد",
    dimensionCountMany: "{count} أبعاد",
    saveDimensionOrderFirst: "احفظ الترتيب الحالي قبل إضافة بُعد آخر.",
    gbeRecallWarning: "استرجاع هذا المستند يزيل إدخالاته نهائيًا من إدخال الميزانية العامة. يتم أرشفة الإدخالات ويمكن مراجعتها تحت 'المسترجعة'. لاستعادتها، أعد إدخال السطور في دفتر يوميات الميزانية العامة وانشرها مرة أخرى.",
    gbeRecallSuccess: "{n} إدخالات الميزانية المسترجعة.",
    deleteSelectedInvoicesWarning: "ستؤدي هذه العملية إلى حذف الفواتير المحددة وجميع تفاصيلها بشكل دائم. لا يمكن التراجع عنها.",
    deleteSelectedInvoicesCount: "سيتم حذف {v} مستند(ات):",
    invoiceWithoutDocumentNo: "(لا يوجد رقم مستند)",
    purchaseBookSummaryTruncated: "الإجماليات تغطي السجلات {v} الأولى فقط. قم بتقليص نطاق التاريخ للحصول على إجمالي دقيق.",
    changeAccountNumberDimensionNotice: "ستتم استبدال مجموعة الأبعاد لهذه الإدخال بالقيم أدناه، المعبأة مسبقًا من الأبعاد الإلزامية لـ {account}. اترك القائمة فارغة لإزالة مجموعة الأبعاد.",
    changeAccountNumberDimensionAssignNotice: "لا توجد أبعاد محددة لهذا الإدخال. {account} يتطلب الأبعاد أدناه، مع القيم الافتراضية. يرجى تأكيدها أو تعديلها قبل الحفظ.",
    successImportCfb: "تم استيراد ميزانية التدفق النقدي بنجاح!",
    successSaveCfb: "تم حفظ ميزانية التدفق النقدي بنجاح!",
  },
  common: {
    add: "إضافة",
    cancel: "إلغاء",
    description: "الوصف",
    delete: "حذف",
    title: "العنوان",
    save: "حفظ",
    faq: "الأسئلة الشائعة",
    contact: "اتصل بنا",
    tos: "شروط الخدمة",
    policy: "سياسة الخصوصية",
    sunday: "الأحد",
    monday: "الاثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    saturday: "السبت",
    clickHere: "انقر هنا",
    standard: "قياسي",
    monospace: "مونو",
    left: "يسار",
    center: "مركز",
    right: "يمين",
  },
  board: {
    titlePlaceholder: "أدخل عنوانًا لهذه البطاقة",
    deleteDescription: "هل أنت متأكد أنك تريد حذف هذه البطاقة؟",
    editCard: "تعديل البطاقة",
    deleteCard: "حذف البطاقة",
    state: {
      TODO: "للعمل",
      INPROGRESS: "قيد التنفيذ",
      TESTING: "اختبار",
      DONE: "تم",
    },
  },
  chat: {
    online: "المستخدمون المتصلون ({count})",
    addChannel: "إضافة قناة",
    channel: "قناة | قنوات",
    message: "رسالة",
  },
  email: {
    compose: "إنشاء بريد إلكتروني",
    send: "إرسال",
    subject: "الموضوع",
    labels: "التصنيفات",
    emptyList: "قائمة البريد الإلكتروني فارغة",
    inbox: "الوارد",
    sent: "المرسل",
    drafts: "المسودات",
    starred: "المميزة بنجمة",
    trash: "المهملات",
    work: "العمل",
    invoice: "فاتورة",
    recipient: "المستلم",
  },
  todo: {
    addTask: "إضافة مهمة",
    tasks: "المهام",
    completed: "مكتمل",
    labels: "التصنيفات",
  },
  dashboard: {
    activity: "النشاط",
    weeklySales: "المبيعات الأسبوعية",
    sales: "المبيعات",
    recentOrders: "الطلبات الأخيرة",
    sources: "مصادر الحركة",
    lastweek: "مقارنة بالأسبوع الماضي",
    orders: "الطلبات",
    clients: "العملاء",
    tickets: "تذاكر الدعم",
    viewReport: "عرض التقرير",
  },
  usermenu: {
    profile: "الملف الشخصي",
    signin: "تسجيل الدخول",
    dashboard: "لوحة التحكم",
    signout: "تسجيل الخروج",
  },
  error: {
    differentVATGroup: "يجب أن تكون مجموعات ترحيل ضريبة القيمة المضافة للمنتجات متطابقة",
    glbImport: "خطأ، لا يمكن استيراد ميزانية دفتر الأستاذ العام",
    notfound: "الصفحة غير موجودة",
    other: "حدث خطأ",
    invoiceAlreadyHaveCreditMemo: "هذه الفاتورة لديها إشعار دائن بالفعل",
    POItemIsFromPR: "عنصر أمر الشراء مصدره طلب شراء",
    locationAndPostingGroupDuplicate: "هذا الموقع ({f1}) ومجموعة الترحيل ({f2}) موجودان بالفعل.<br/>يرجى اختيار قيمة أخرى!",
    businessAndProductPostingGroupDuplicate: "هذا العمل ({f1}) ومجموعة ترحيل المنتجات ({f2}) موجودان بالفعل.<br/>يرجى اختيار قيمة أخرى!",
    invoiceAlreadyPaid: "تم دفع هذه الفاتورة جزئيًا أو كليًا.<br/>المبلغ الأصلي: {f1}<br/>المبلغ المتبقي: {f2}",
    needConfigureVatProduct: "يرجى إعداد مجموعة ترحيل ضريبة القيمة المضافة للمنتجات في إعدادات العميل أو الذمم المدينة",
    failedFetchItemCost: "فشل في جلب تكلفة العنصر الأخيرة",
    syncPrLineFailed: "فشل في مزامنة التغييرات على خط طلب الشراء. تم حفظ تغييرات الطلب.",
    needConfigureDirectCostAccount: "يرجى إعداد حساب التكلفة المباشرة في إعداد المدفوعات المستحقة للشراء",
    needConfigurePurchaseAccount: "يرجى إعداد حساب الشراء في إعدادات المدفوعات المستحقة",
    noPermission: "ليس لديك إذن لأداء هذا الإجراء",
    cfbImport: "خطأ، لا يمكن استيراد ميزانية التدفق النقدي",
    noAppliedEntriesOnThisDocument: "لا توجد إدخالات مطبقة على هذه الوثيقة",
    noCompanyHeaderInfo: "لا توجد معلومات رأس الشركة. يرجى الاتصال بالمسؤول.",
  },
  check: {
    title: "تعيين كلمة مرور جديدة",
    backtosign: "العودة لتسجيل الدخول",
    newpassword: "كلمة مرور جديدة",
    button: "تعيين كلمة مرور جديدة وتسجيل الدخول",
    error: "رابط الإجراء غير صالح",
    verifylink: "جارٍ التحقق من الرابط...",
    verifyemail: "جارٍ التحقق من عنوان البريد الإلكتروني...",
    emailverified: "تم التحقق من البريد الإلكتروني! جارٍ إعادة التوجيه...",
  },
  forgot: {
    title: "هل نسيت كلمة المرور؟",
    subtitle: "أدخل عنوان بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
    email: "البريد الإلكتروني",
    button: "طلب إعادة تعيين كلمة المرور",
    backtosign: "العودة لتسجيل الدخول",
  },
  login: {
    title: "تسجيل الدخول",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    button: "تسجيل الدخول",
    orsign: "أو سجل الدخول بواسطة",
    forgot: "هل نسيت كلمة المرور؟",
    noaccount: "ليس لديك حساب؟",
    create: "أنشئ حسابًا هنا",
    error: "تركيبة البريد الإلكتروني / كلمة المرور غير صحيحة",
  },
  register: {
    title: "إنشاء حساب",
    name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    passwordRetype: "أعد إدخال كلمة المرور",
    button: "إنشاء حساب",
    orsign: "أو سجل بواسطة",
    agree: "بالتسجيل، أنت توافق على",
    account: "هل لديك حساب بالفعل؟",
    signin: "تسجيل الدخول",
  },
  utility: {
    maintenance: "تحت الصيانة",
  },
  faq: {
    call: "هل لديك أسئلة أخرى؟ يرجى التواصل معنا ",
  },
  ecommerce: {
    products: "المنتجات",
    filters: "الفلاتر",
    collections: "المجموعات",
    priceRange: "نطاق السعر",
    clientReviews: "مراجعات العملاء",
    up: "وأعلى",
    brand: "العلامة التجارية",
    search: "ابحث عن منتج",
    results: "النتائج ( {0} من {1} )",
    orders: "الطلبات",
    shipping: "الشحن",
    freeShipping: "شحن مجاني",
    inStock: "متوفر في المخزون",
    quantity: "الكمية",
    addToCart: "أضف إلى السلة",
    buyNow: "اشتر الآن",
    price: "السعر",
    about: "حول هذا المنتج",
    description: "الوصف",
    reviews: "المراجعات",
    details: "تفاصيل المنتج",
    cart: "السلة",
    summary: "ملخص الطلب",
    total: "الإجمالي",
    discount: "خصم",
    subtotal: "المجموع الفرعي",
    continue: "متابعة التسوق",
    checkout: "الدفع",
  },
  menu: {
    rateManagement: "إدارة الأسعار",
    reservation: "الحجز",
    reservationNew: "جديد",
    reservationList: "قائمة",
    frontOffice: "الاستقبال",
    generalSettings: "الإعدادات العامة",
    guestTitle: "لقب الضيف",
    guestDocumentType: "نوع مستند الضيف",
    manageHotel: "إدارة الفندق",
    hotel: "فندق",
    hotelList: "قائمة الفنادق",
    hotelCategory: "فئة الفندق",
    hotelChain: "سلسلة الفنادق",
    marketSegment: "القطاع السوقي",
    rooms: "الغرف",
    currency: "العملة",
    search: "بحث (اضغط \"ctrl + /\" للتركيز)",
    dashboard: "لوحة التحكم",
    logout: "تسجيل الخروج",
    flushSiteData: "مسح بيانات الموقع",
    clearCache: "مسح الكاش",
    profile: "الملف الشخصي",
    blank: "صفحة فارغة",
    pages: "الصفحات",
    others: "أخرى",
    email: "البريد الإلكتروني",
    chat: "الدردشة",
    todo: "المهام",
    board: "لوحة المهام",
    users: "المستخدمون",
    usersList: "قائمة",
    usersEdit: "تعديل",
    ecommerce: "التجارة الإلكترونية",
    ecommerceList: "المنتجات",
    ecommerceProductDetails: "تفاصيل المنتج",
    ecommerceOrders: "الطلبات",
    ecommerceCart: "السلة",
    auth: "صفحات المصادقة",
    authLogin: "تسجيل الدخول / دخول",
    authRegister: "تسجيل / إنشاء حساب",
    authVerify: "تأكيد البريد الإلكتروني",
    authForgot: "نسيت كلمة المرور",
    authReset: "إعادة تعيين كلمة المرور",
    errorPages: "صفحات الخطأ",
    errorNotFound: "غير موجود / 404",
    errorUnexpected: "غير متوقع / 500",
    utilityPages: "صفحات الأدوات",
    utilityMaintenance: "الصيانة",
    utilitySoon: "قريباً",
    utilityHelp: "الأسئلة الشائعة / المساعدة",
    levels: "مستويات القائمة",
    disabled: "القائمة معطلة",
    docs: "التوثيق",
    feedback: "ملاحظات",
    support: "الدعم",
    history: "السجل",
  },
  localColumns: {
    defaultVatProductPostingGroup: "مجموعة ترحيل ضريبة القيمة المضافة الافتراضية للمنتجات",
    defaultWhtProductPostingGroup: "مجموعة الاستقطاع الافتراضية",
    postingGroup: "مجموعة الترحيل",
    postingType: "نوع الترحيل",
    inventoryPostingType: "نوع ترحيل المخزون",
    isWitholdingTax: "ضريبة استقطاع",
    isNoVat: "بدون ضريبة القيمة المضافة",
    batchName: "اسم الدفعة",
    batchCode: "رمز الدفعة",
    totalRecords: "إجمالي السجلات",
    totalAmount: "إجمالي المبلغ",
    totalDebit: "إجمالي المدين",
    totalCredit: "إجمالي الدائن",
    journalName: "اسم اليومية",
    company: "الشركة",
    offsetCompany: "شركة المقابلة",
    offsetAccount: "حساب المقابلة",
    isPom: "POM؟",
    sentecAccountNo: "رقم حساب Sentec",
    sentecAccountName: "اسم حساب Sentec",
    salesPersonName: "اسم مندوب المبيعات",
    guestAccountName: "اسم الضيف / الحساب",
    contactPersonName: "اسم جهة الاتصال",
    creditLimit: "حد الائتمان",
    remainingBalance: "الرصيد المتبقي",
    vleAmount: "مبلغ VLE",
    gleAmount: "مبلغ GLE",
    cleAmount: "مبلغ CLE",
    diff: "فرق",
    SOHQuantity: "كمية SOH",
    IABQuantity: "كمية IAB",
    SOHTotalCost: "إجمالي تكلفة SOH",
    COAAmount: "مبلغ COA",
    costDifference: "فرق التكلفة",
    isGeneralStorage: "تخزين عام",
    generalLedgerEntryId: "معرف قيد دفتر الأستاذ العام",
    operator: "مشغل",
    ilePostingDate: "تاريخ نشر ILE",
    receivableDate: "تاريخ الاستحقاق",
    receivableDueDate: "تاريخ استحقاق الذمم المدينة",
    receivablePostingDate: "تاريخ تسجيل المستحقات",
  },
  localCommon: {
    noMenuMatchedWithSearchQuery: "لا يوجد قائمة مطابقة لبحثك",
    top10VendorByBalance: "أفضل 10 موردين حسب الرصيد",
    top10ClientsByBalance: "أفضل 10 عملاء حسب الرصيد",
    chooseTime: "اختر الوقت",
    top10PurchaseItem: "أفضل 10 عناصر شراء",
    adjustEntry: "تعديل القيد",
    split: "تقسيم",
    postBatch: "ترحيل دفعة",
    processing: "جارٍ المعالجة",
    generalLedgerBudget: "ميزانية دفتر الأستاذ العام",
    inventory: "المخزون",
  },
  coaIntegration: {
    title: "تكامل COA",
    titleMapping: "تعيين COA",
    provider: "المزود",
    dataLog: "سجل البيانات",
    flushDataLog: "مسح السجل",
    successSaveConfig: "تم تحديث الإعدادات",
    successGenerateData: "تم إنشاء البيانات",
    successSendData: "تمت معالجة البيانات، يرجى التحقق من الاستجابة",
    successFlushData: "تم مسح سجل البيانات",
    successUpdateMappingData: "تم تحديث التعيين",
    successDeleteMappingData: "تم حذف التعيين",
    inputSystemChartOfAccount: "حساب COA للنظام",
    deleteMappingConfirm: "هل أنت متأكد أنك تريد حذف هذا السجل؟ لا يمكن التراجع عن هذه العملية.",
    deleteDataLogByMonthConfirm: "هل أنت متأكد أنك تريد حذف جميع السجلات حسب الشهر المحدد؟ لا يمكن التراجع عن هذه العملية.",
    deleteDataLogAllConfirm: "هل أنت متأكد أنك تريد حذف جميع السجلات؟ لا يمكن التراجع عن هذه العملية.",
    baseUrl: "عنوان URL الأساسي",
  },
  $vuetify: {
    badge: "شارة",
    close: "إغلاق",
    dataIterator: {
      noResultsText: "لا توجد سجلات مطابقة",
      loadingText: "جارٍ تحميل العناصر...",
    },
    dataTable: {
      itemsPerPageText: "صفوف لكل صفحة:",
      ariaLabel: {
        sortDescending: "تم الترتيب تنازليًا.",
        sortAscending: "تم الترتيب تصاعديًا.",
        sortNone: "غير مرتب.",
        activateNone: "اضغط لإلغاء الترتيب.",
        activateDescending: "اضغط للترتيب تنازليًا.",
        activateAscending: "اضغط للترتيب تصاعديًا.",
      },
      sortBy: "ترتيب حسب",
    },
    dataFooter: {
      itemsPerPageText: "عناصر لكل صفحة:",
      itemsPerPageAll: "الكل",
      nextPage: "الصفحة التالية",
      prevPage: "الصفحة السابقة",
      firstPage: "الصفحة الأولى",
      lastPage: "الصفحة الأخيرة",
      pageText: "{0}-{1} من {2}",
    },
    datePicker: {
      itemsSelected: "{0} محدد",
      nextMonthAriaLabel: "الشهر التالي",
      nextYearAriaLabel: "السنة التالية",
      prevMonthAriaLabel: "الشهر السابق",
      prevYearAriaLabel: "السنة السابقة",
    },
    noDataText: "لا توجد بيانات متاحة",
    carousel: {
      prev: "العرض السابق",
      next: "العرض التالي",
      ariaLabel: {
        delimiter: "شريحة {0} من {1}",
      },
    },
    calendar: {
      moreEvents: "{0} المزيد",
    },
    fileInput: {
      counter: "{0} ملفات",
      counterSize: "{0} ملفات ({1} إجمالي)",
    },
    timePicker: {
      am: "ص",
      pm: "م",
    },
    pagination: {
      ariaLabel: {
        wrapper: "تنقل الصفحات",
        next: "الصفحة التالية",
        previous: "الصفحة السابقة",
        page: "انتقل إلى الصفحة {0}",
        currentPage: "الصفحة الحالية، صفحة {0}",
      },
    },
  },
  userPostingSetup: {
    setPostingDate: "تعيين تاريخ الترحيل لجميع المستخدمين",
  },
  purchaseRequisitionBatch: {
    allowedApprovalSubmissionDays: "أيام السماح لتقديم الموافقة",
  },
  generalLedgerBudget: {
    editTitle: "تعديل الميزانية",
    title: "استيراد من XLS",
    successImportData: "تم استيراد البيانات!",
  },
  balanceSheetConsolidation: {
    title: "توحيد الميزانية العمومية",
    titleReport: "تقرير دمج الميزانية العمومية",
    excelFileID: "معرّف ملف إكسل لتوحيد الميزانية العمومية",
    sheetFileID: "معرّف ملف جوجل شيت لتوحيد الميزانية العمومية",
  },
  documentFlow: {
    purchaseInvoiceDefaultDocumentFlow: "تدفق مستند الفاتورة الافتراضي للشراء",
    purchaseInvoiceDocumentFlowRules: "قواعد تدفق مستند فاتورة الشراء",
    equal: "متساوي",
    notEqual: "غير متساوي",
    lessThan: "أقل من",
    lessThanOrEqual: "أقل من أو يساوي",
    greaterThan: "أكبر من",
    greaterThanOrEqual: "أكبر من أو يساوي",
    purchaseOrderDocumentFlowRules: "قواعد تدفق مستندات أمر الشراء",
    purchaseReceiptDocumentFlowRules: "قواعد تدفق مستندات إيصال الشراء",
    default: "تدفق المستندات الافتراضي",
    purchaseOrderDMLDocumentFlowRules: "قواعد تدفق مستندات أمر الشراء لقائمة السوق اليومية",
    documentsSourceInformation: "المستندات المعروضة في هذه الصفحة هي من المكتب الخلفي فقط (مثل: PI، PO، PR، إلخ). يمكن عرض المستندات التي تم إنشاؤها بواسطة المكتب الأمامي في وحدة المكتب الأمامي.",
    refreshApprovals: "تحديث الموافقات",
    showInformation: "عرض المعلومات",
    submitForApprovalConfirmation: "سيتم إرسال طلبات الموافقة عبر البريد الإلكتروني إلى هؤلاء المستخدمين. يرجى التأكد من صحة المعلومات.",
    hideInformation: "إخفاء المعلومات",
    documentFlowBeingUsed: "تدفق المستندات قيد الاستخدام",
    sendEmail: "أرسل بريد إلكتروني",
    sendReminder: "إرسال تذكير",
    reminderCount: "عدد التذكيرات",
    remindedAt: "تاريخ التذكير",
  },
  changesLog: {
    logCategory: "فئة السجل",
    sourceId: "معرّف المصدر",
  },
  taxSubmission: {
    availableToCancelOrReject: "متاح للإلغاء/الرفض",
    availableToGetSubmittedDetails: "متاح للحصول على تفاصيل المقدمات",
    availableToSend: "متاح للإرسال",
    buyerAddress: "عنوان المشتري",
    buyerContractName: "اسم عقد المشتري",
    buyerName: "اسم المشتري",
    buyerRegistrationNumber: "رقم تسجيل المشتري",
    buyerSSTRegistrationID: "معرّف تسجيل ضريبة المبيعات والخدمات للمشتري",
    buyerTIN: "رقم التعريف الضريبي للمشتري",
    classification: "تصنيف",
    eInvoice: "الفاتورة الإلكترونية",
    eInvoiceCode: "رمز الفاتورة الإلكترونية",
    eInvoiceType: "نوع الفاتورة الإلكترونية",
    eInvoiceVersion: "نسخة الفاتورة الإلكترونية",
    invoiceDateAndTime: "تاريخ ووقت الفاتورة",
    originalInvoiceRefNo: "رقم المرجع للفاتورة الأصلية: غير قابل للتطبيق",
    sendCountInvoicesToTaxInterface: "إرسال {count} فاتورة إلى واجهة الضرائب",
    subtotal: "المجموع الفرعي",
    supplierBusinessActivityDescription: "وصف نشاط عمل المورد",
    supplierMSICCode: "رمز MSIC للمورد",
    supplierRegistrationNumber: "رقم تسجيل المورد",
    supplierSSTID: "معرّف SST للمورد",
    supplierTIN: "رقم التعريف الضريبي للمورد",
    taxRate: "نسبة الضريبة",
    totalExcludingTax: "الإجمالي بدون ضريبة",
    totalIncludingTax: "الإجمالي شامل الضريبة",
    totalPayableAmount: "المبلغ الإجمالي المستحق",
    uniqueIdentifierNo: "رقم التعريف الفريد",
    unitPrice: "سعر الوحدة",
    digitalSignature: "التوقيع الرقمي",
    validationDateTime: "تاريخ ووقت التحقق",
    visualPresentation: "هذه الوثيقة تمثل عرضًا بصريًا للفاتورة الإلكترونية",
    na: "غير متاح",
    getSubmittedDocumentURL: "احصل على رابط الوثيقة المقدمة",
    cancelOrRejectDocument: "إلغاء أو رفض المستند",
    interfaceStatus: "حالة الواجهة",
    receiptVerificationRedirectURL: "رابط إعادة توجيه التحقق من الإيصال",
    receiptVerificationSubmissionUUID: "معرّف تقديم التحقق من الإيصال",
    receiptVerificationDocumentUUID: "معرّف UUID لوثيقة التحقق من الإيصال",
    reject: "رفض",
  },
  template: {
    columnLengthDifference: "نموذج غير صالح: عدد الأعمدة غير متطابق.",
  },
  radio: {
    autoclose: "إغلاق تلقائي",
    manualclose: "إغلاق يدوي",
  },
  cashFlowBudget: {
    editTitle: "تعديل الميزانية",
    title: "استيراد من XLS",
    successImportData: "تم استيراد البيانات!",
  },
};
